








































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { Modal as AntModal } from 'ant-design-vue';

import Toast from '@/mixins/toast';
import Modal from '@/components/UI/Modal.vue';
import ColumnTitleContent from '@/components/UI/Table/ColumnTitleContent.vue';

import MmHintedButton from '../../components/MmHintedButton.vue';
import MmPhotoGallery from '../../components/MmPhotoGallery.vue';
import MmStates from '../../components/MmStates.vue';
import MmStatusBadge from '../../components/MmStatusBadge.vue';
import MmTable from '../../components/MmTable.vue';
import TaskResultsBulkBar from './TaskResultsBulkBar.vue';

import { createCancelSource, MmRequestConfig, readMmError } from '../../api/mmHttp';
import {
	buildPageQuery,
	createPaginationState,
	createSortingState,
	hasNextPage,
	MM_QUERY_PARAM_NAMES,
	MmPaginationState,
	MmSortingState,
} from '../../api/pagination';
import {
	bulkReviewResults,
	correctResultPrice,
	fetchMonitoringResultsByIds,
	fetchPriceCheckerPhoto,
	fetchResultGroups,
	fetchResults,
	MmBulkReviewAction,
} from '../../api/results';
/** План задания грузим ради эталонных цен: они лежат в позиции плана, а не в результате */
import { fetchTaskItems } from '../../api/taskItems';
import { formatDiagnostics, isCanceled, MmError } from '../../core/errors';
import { formatDateTime, formatLevelPath, formatMoney, MM_EMPTY_DASH, orDash } from '../../core/format';
import { resolveTaskMonitoringLevel } from '../../core/monitoringLevel';
import { normalizeSkipReason, resolveOutcome } from '../../core/outcome';
import {
	buildSelectCheckBoxesData,
	buildSelectionIndex,
	createSelectionState,
	isRowSelected,
	isSelectionEmpty,
	MM_RESULT_SELECTION_FIELDS,
	MmSelectionIndex,
	MmSelectionState,
	resetSelection,
	resetSelectionArrays,
	selectedCount,
	toggleRow,
} from '../../core/selection';
import { getSessionStore } from '../../core/session';
import { getSpSessionFingerprint } from '../../core/spSession';
import { getBadgeSpec, listDomainEntries, MmBadgeEntry, skipReasonKey } from '../../core/statuses';
import {
	MmMonitoringResult,
	MmPhoto,
	MmPriceCheckerRecord,
	MmTask,
	MmTaskClassification,
	MmTaskItem,
} from '../../types/domain';
import { MmPage, MmResultGroupAggregate, MmResultGroupsResponse, MmResultListFilters } from '../../types/dto';
import {
	MmMonitoringLevel,
	MmOutcome,
	MmReviewStatus,
	MmTaskStatus,
	MmTaskType,
} from '../../types/enums';
import {
	createDefaultTaskResultsContext,
	MmTaskCardExtensionContext,
	MmTaskResultsBulkBarPayload,
	MmTaskResultsContext,
	MmTaskResultsRowActionsPayload,
} from './taskCardExtensions';
import {
	getTaskTypeResultProfile,
	listDefaultVisibleResultColumns,
	listResultColumns,
	MM_RESULT_COLUMN_AUTO_WIDTH,
	MmResultColumnSpec,
	MmTaskTypeResultProfile,
} from './taskTypeProfile';
import { isTaskAwaitingClose } from '../results/batch';

const KEY = 'priceMonitoring.mobileMonitoring.taskResults.';

const PHOTOS_KEY = 'priceMonitoring.mobileMonitoring.photos.';

const SECTION_GROUPS = 'results/groups';
const SECTION_LIST = 'results/list';

const GROUP_PAGE_SIZE = 50;

const PLAN_PAGE_SIZE = 200;
const PLAN_MAX_PAGES = 20;

const PLAN_MAX_TASKS = 40;

const MM_KVI_DEVIATION_LIMIT_PERCENT = 10;

const LATE_DATA_HOURS = 6;

const STORAGE_PREFIX = 'mm_results_v1';

type MmNodeStatus = 'idle' | 'loading' | 'loaded' | 'error';

interface MmResultNodeCounters {
	positionsTotal: number;
	positionsWithPrice: number;
	positionsPending: number;
	positionsNotFound: number | null;
	positionsSkipped: number | null;
	positionsPriceNotRecognized: number | null;
	positionsUnspecified: number | null;
	positionsReviewed: number | null;
	photosTotal: number | null;
	priceMin: number | null;
	priceMax: number | null;
}

interface MmResultRow {
	key: string;
	result: MmMonitoringResult | null;
	classification: MmTaskClassification | null;
	/** Заполнено только у синтезированных строк «Не выполнено», у строк-результатов здесь null */
	planItem: MmTaskItem | null;
	isMissing: boolean;
	isDuplicate: boolean;
	extraCaptures: number;
}

interface MmCounterChip {
	key: string;
	label: string;
	value: string;
	tone: string;
}

interface MmResultBanner {
	key: string;
	tone: string;
	icon: string;
	title: string;
	text: string;
	quote: string;
	action: string;
}

interface MmPriceCheckerView {
	id: string;
	price: string;
	promoPrice: string;
	capturedAt: string;
	photoSrc: string;
	currency: string;
	gps: string;
	confidence: string;
	skipReason: string;
	skipComment: string;
	hasEdit: boolean;
	originalPrice: string;
	editedPrice: string;
}

/** Тип описан структурно: импортировать его из .vue TypeScript не умеет */
interface MmTableChangePayload {
	pagination: MmPaginationState;
	sorter: MmSortingState;
	filters: { [key: string]: any };
}

function keyOfResultId(id: string): string {
	return String(id);
}

interface MmResultsViewState {
	columns: string[];
	onlyLatest: boolean;
	onlyUnspecifiedOutcome: boolean;
	onlyAnalogs: boolean;
}

@Component({
	components: {
		ColumnTitleContent,
		MmHintedButton,
		MmPhotoGallery,
		MmStates,
		MmStatusBadge,
		MmTable,
		Modal,
		TaskResultsBulkBar,
	},
})
export default class TaskResultsTable extends Mixins(Toast) {
	@Prop({ required: true }) readonly taskId!: string;

	@Prop({ default: null }) readonly task!: MmTask | null;

	@Prop({ default: null }) readonly tradingId!: number | null;

	@Prop({ default: true }) readonly isActive!: boolean;

	@Prop({ default: null }) readonly highlightResultId!: string | null;

	@Prop({ default: null }) readonly highlightClassificationId!: string | null;

	/** null — режим «одно задание»; значение по умолчанию подставляет геттер ctx */
	@Prop({ default: null }) readonly context!: MmTaskResultsContext | null;

	/** Геттер, а не поле: при переходе к другому заданию значение обязано пересчитаться */
	get ctx(): MmTaskResultsContext {
		return this.context !== null ? this.context : createDefaultTaskResultsContext(this.taskId);
	}

	get isBulkReviewAllowed(): boolean {
		return this.ctx.allowBulkReview !== false;
	}

	get tableTitleKey(): string {
		const key = this.ctx.titleKey;

		return key !== null && key !== '' ? key : 'priceMonitoring.mobileMonitoring.taskResults.title';
	}

	private loadGroupsFromContext(config: MmRequestConfig): Promise<MmResultGroupsResponse> {
		const custom = this.ctx.loadGroups;

		if (custom !== null) {
			return custom(config);
		}

		if (this.tradingId !== null && this.taskId) {
			return this.loadLiveSummary(config);
		}

		return fetchResultGroups(this.taskId, config).then((response) => {
			const data: any = response && response.data ? response.data : {};

			return {
				items: Array.isArray(data.items) ? data.items : [],
				monitoringLevel: data.monitoringLevel ? String(data.monitoringLevel) : null,
				resultsTotal: typeof data.resultsTotal === 'number' ? data.resultsTotal : null,
				resultsUnspecifiedTotal:
					typeof data.resultsUnspecifiedTotal === 'number' ? data.resultsUnspecifiedTotal : null,
			};
		});
	}

	private loadResultsFromContext(
		filters: any,
		pageParams: { [key: string]: any },
		config: MmRequestConfig,
	): Promise<MmPage<MmMonitoringResult>> {
		const custom = this.ctx.loadResults;

		if (custom !== null) {
			return custom(filters, pageParams, config);
		}

		const tradingId = this.tradingId;

		if (tradingId === null) {
			return Promise.resolve({ content: [], totalElements: 0, totalKnown: true, hasMore: null });
		}

		if (this.taskId) {
			return this.loadLiveRows(filters, pageParams, config);
		}

		return fetchResults(tradingId, filters, pageParams, config);
	}

	private loadLiveSummary(config: MmRequestConfig): Promise<MmResultGroupsResponse> {
		return fetchMonitoringResultsByIds(null, [this.taskId], config).then((rows) => {
			const filtered = this.applyLiveFilters(rows, this.buildListFilters());
			let unspecified = 0;

			for (let i = 0; i < filtered.length; i += 1) {
				if (filtered[i].outcome === MmOutcome.UNSPECIFIED) {
					unspecified += 1;
				}
			}

			return {
				items: [],
				monitoringLevel: null,
				resultsTotal: filtered.length,
				resultsUnspecifiedTotal: unspecified,
			};
		});
	}

	private loadLiveRows(
		filters: any,
		pageParams: { [key: string]: any },
		config: MmRequestConfig,
	): Promise<MmPage<MmMonitoringResult>> {
		return fetchMonitoringResultsByIds(null, [this.taskId], config).then((all) => {
			const filtered = this.applyLiveFilters(all, filters);
			const total = filtered.length;
			const sorted = this.applyLiveSorting(filtered, pageParams);
			const current = this.readLiveCurrent(pageParams);
			const pageSize = this.readLivePageSize(pageParams);
			const start = (current - 1) * pageSize;
			const content = sorted.slice(start, start + pageSize);

			return { content: content, totalElements: total, totalKnown: true, hasMore: null };
		});
	}

	private applyLiveFilters(rows: MmMonitoringResult[], filters: any): MmMonitoringResult[] {
		const f: any = filters ? filters : {};
		let result = rows.slice();

		if (f.onlyAnalogs === true) {
			result = result.filter((r) => r.isAnalog === true);
		}

		if (f.onlyUnspecifiedOutcome === true) {
			result = result.filter((r) => r.outcome === MmOutcome.UNSPECIFIED);
		}

		if (f.onlyLatest === true) {
			result = this.keepLatestCaptures(result);
		}

		return result;
	}

	private keepLatestCaptures(rows: MmMonitoringResult[]): MmMonitoringResult[] {
		const best: { [key: string]: MmMonitoringResult } = {};

		for (let i = 0; i < rows.length; i += 1) {
			const row = rows[i];
			const key = this.liveCaptureKey(row);
			const existing = best[key];

			if (existing === undefined || this.liveCaptureTime(row) >= this.liveCaptureTime(existing)) {
				best[key] = row;
			}
		}

		const out: MmMonitoringResult[] = [];

		for (const k in best) {
			if (Object.prototype.hasOwnProperty.call(best, k)) {
				out.push(best[k]);
			}
		}

		return out;
	}

	private liveCaptureKey(row: MmMonitoringResult): string {
		const code = this.readRawField(row, 'barCode');
		const identity = code !== '' ? code : String(row.id);

		return String(row.taskId) + '|' + identity;
	}

	private liveCaptureTime(row: MmMonitoringResult): string {
		return row.capturedAt ? String(row.capturedAt) : '';
	}

	private applyLiveSorting(rows: MmMonitoringResult[], pageParams: { [key: string]: any }): MmMonitoringResult[] {
		const rawBy = pageParams ? pageParams[MM_QUERY_PARAM_NAMES.sortBy] : null;
		const rawDir = pageParams ? pageParams[MM_QUERY_PARAM_NAMES.sortDirection] : null;
		const sortBy = rawBy === null || rawBy === undefined ? '' : String(rawBy);
		const order = rawDir === null || rawDir === undefined ? '' : String(rawDir);

		if (sortBy === '' || order === '') {
			return rows;
		}

		const dir = order === 'desc' ? -1 : 1;
		const copy = rows.slice();

		copy.sort((a, b) => {
			const c = this.liveCompare(a, b, sortBy);

			return c === 0 ? 0 : c * dir;
		});

		return copy;
	}

	private liveCompare(a: MmMonitoringResult, b: MmMonitoringResult, field: string): number {
		if (field === 'price') {
			const va = a.price !== null && a.price !== undefined ? a.price : Number.POSITIVE_INFINITY;
			const vb = b.price !== null && b.price !== undefined ? b.price : Number.POSITIVE_INFINITY;

			return va === vb ? 0 : va < vb ? -1 : 1;
		}

		if (field === 'capturedAt') {
			const sa = a.capturedAt ? String(a.capturedAt) : '';
			const sb = b.capturedAt ? String(b.capturedAt) : '';

			return sa === sb ? 0 : sa < sb ? -1 : 1;
		}

		if (field === 'productName') {
			const na = this.readRawField(a, 'recognizedName');
			const nb = this.readRawField(b, 'recognizedName');

			return na === nb ? 0 : na < nb ? -1 : 1;
		}

		return 0;
	}

	/** Номер страницы (1-индексный) из параметров запроса (`page = current - 1`). */
	private readLiveCurrent(pageParams: { [key: string]: any }): number {
		const raw = pageParams ? pageParams[MM_QUERY_PARAM_NAMES.page] : null;
		const pageZero = typeof raw === 'number' ? raw : Number(raw);

		return isFinite(pageZero) && pageZero >= 0 ? pageZero + 1 : 1;
	}

	private readLivePageSize(pageParams: { [key: string]: any }): number {
		const raw = pageParams ? pageParams[MM_QUERY_PARAM_NAMES.size] : null;
		const size = typeof raw === 'number' ? raw : Number(raw);

		return isFinite(size) && size > 0 ? size : GROUP_PAGE_SIZE;
	}

	aggregates: MmResultGroupAggregate[] = [];
	monitoringLevel: string = 'group';
	resultsTotal: number = 0;

	/** null — поле не пришло от сервера, это не ноль */
	resultsUnspecifiedTotal: number | null = null;
	isSummaryLoading: boolean = false;
	loadError: MmError | null = null;

	planItems: { [key: string]: MmTaskItem } = {};

	private planSource: any = null;

	rows: MmResultRow[] = [];
	listPagination: MmPaginationState = createPaginationState(GROUP_PAGE_SIZE);
	listStatus: MmNodeStatus = 'idle';
	listError: MmError | null = null;

	private hasLoadedRows: boolean = false;

	visibleColumnKeys: string[] = [];
	onlyLatest: boolean = false;
	onlyUnspecifiedOutcome: boolean = false;
	onlyAnalogs: boolean = false;
	draftOnlyLatest: boolean = false;
	draftOnlyUnspecifiedOutcome: boolean = false;
	draftOnlyAnalogs: boolean = false;

	/** Здесь пустое состояние: в data() вычисляемых свойств нет, значение по умолчанию ставит mounted() */
	sorting: MmSortingState = createSortingState();

	selection: MmSelectionState<string> = createSelectionState<string>();
	isBulkBusy: boolean = false;

	editingRowKey: string | null = null;
	editValue: string = '';
	editError: string = '';
	savingRowKey: string | null = null;

	/** Ответ сервера двигает режим правки и фокус, только если счётчик сессии не менялся */
	editRunId: number = 0;

	rejectRow: MmResultRow | null = null;
	rejectComment: string = '';
	rejectError: string = '';

	rejectInPhoto: boolean = false;

	photoRowKey: string = '';

	/** Держит открытую строку, даже если фильтр убрал её из таблицы */
	photoAnchorRow: MmResultRow | null = null;

	photoStartIndex: number = 0;

	photoQueue: MmResultRow[] = [];

	priceCheckerRow: MmResultRow | null = null;
	priceCheckerPhotoSrc: { [entryId: string]: string } = {};
	private priceCheckerObjectUrls: string[] = [];

	isDeepLinkMissed: boolean = false;
	highlightedKey: string = '';

	private handledHighlightId: string = '';

	/** Пока сводка не пришла, счётчик нулевой — без этого признака экран соврал бы «не найдено» */
	private hasLoadedSummary: boolean = false;

	private summarySource: any = null;
	private listSource: any = null;
	private needsReload: boolean = false;

	/** Пока галерея открыта, список не перечитываем; после закрытия нужен полный перезапрос */
	private suppressPhotoFlush: boolean = false;

	session = getSessionStore();

	mounted(): void {
		this.applyDefaultSorting();
		this.restoreViewState();
		this.reload();
	}

	private applyDefaultSorting(): void {
		this.sorting = this.ctx.scope === 'batch'
			? createSortingState('capturedAt', 'desc')
			: createSortingState();
	}

	beforeDestroy(): void {
		if (this.isPhotoVisible) {
			this.notifyReviewComplete();
		}

		this.revokePriceCheckerPhotos();
		this.cancelAllRequests();
	}

	@Watch('taskId')
	onTaskIdChanged(): void {
		this.cancelAllRequests();
		this.resetAllState();
		this.restoreViewState();
		this.reload();
	}

	/** Идентификатор задания мог не измениться, а область другая — без сброса протекают быстрые фильтры */
	@Watch('ctx.scopeKey')
	onScopeKeyChanged(newKey: string | null, oldKey: string | null): void {
		if (oldKey === undefined || newKey === oldKey || this.ctx.scope !== 'batch') {
			return;
		}

		this.cancelAllRequests();
		this.resetAllState();
		this.restoreViewState();
		this.reload();
	}

	@Watch('session.readyTick')
	onSessionReady(): void {
		if (!this.isActive) {
			this.needsReload = true;

			return;
		}

		this.reload();
	}

	@Watch('isActive')
	onActiveChanged(next: boolean): void {
		if (next === true && this.needsReload) {
			this.needsReload = false;
			this.reload();
		}
	}

	@Watch('task')
	onTaskChanged(): void {
		if (this.visibleColumnKeys.length === 0) {
			// Сохранённый набор колонок читаем повторно: до появления типа он был бы отброшен целиком
			this.restoreViewState();
		}

		this.ensurePriceCheckerColumn();

		if (this.aggregates.length === 0 && !this.isSummaryLoading) {
			this.reload();
		}
	}

	@Watch('highlightResultId')
	onHighlightChanged(): void {
		this.applyPendingHighlight();
	}

	reload(): void {
		if (this.isPhotoVisible) {
			this.needsReload = true;

			return;
		}

		this.loadPlan();
		this.loadSummary();
	}

	clearSelection(): void {
		resetSelection(this.selection);
	}

	/** Параметр classificationId оставлен в сигнатуре: метод публичный, его зовут через $refs */
	focusResult(resultId: string, classificationId: string | null): void {
		this.isDeepLinkMissed = false;

		const loadedKey = this.findLoadedRowKey(resultId);

		if (loadedKey === '') {
			this.isDeepLinkMissed = true;

			return;
		}

		this.highlightRow(loadedKey);
	}

	/** Кроме наблюдателя, подсветку включает обработчик агрегатов: immediate дал бы ложное «не найдено» */
	private applyPendingHighlight(): void {
		const id = this.highlightResultId === null ? '' : String(this.highlightResultId);

		if (id === '' || id === this.handledHighlightId || !this.hasLoadedSummary) {
			return;
		}

		this.handledHighlightId = id;
		this.focusResult(id, this.highlightClassificationId);
	}

	get taskType(): MmTaskType | null {
		return this.task !== null ? this.task.type : null;
	}

	get resultProfile(): MmTaskTypeResultProfile | null {
		return getTaskTypeResultProfile(this.taskType);
	}

	get levelIsRowKey(): boolean {
		return this.resultProfile !== null ? this.resultProfile.levelIsRowKey : false;
	}

	get canDeletePositions(): boolean {
		return this.resultProfile !== null ? this.resultProfile.canDeletePositions : false;
	}

	get detectsDuplicates(): boolean {
		return this.resultProfile !== null ? this.resultProfile.detectsDuplicates : false;
	}

	get showsMissingRows(): boolean {
		return this.resultProfile !== null ? this.resultProfile.showsMissingRows : false;
	}

	get columnCatalog(): MmResultColumnSpec[] {
		return listResultColumns(this.taskType, this.ctx.scope);
	}

	get hasFoundKindColumn(): boolean {
		return this.hasColumnInCatalog('foundKind');
	}

	get hasTpcSubcategoryColumn(): boolean {
		return this.hasColumnInCatalog('tpcSubcategory');
	}

	get hasPriceCheckerColumn(): boolean {
		return this.hasColumnInCatalog('priceChecker');
	}

	get photoShowsPriceChecker(): boolean {
		return this.hasPriceCheckerColumn && this.isPriceCheckerEnabled;
	}

	/** Сопоставление аналога есть только у KVI, признак тот же, что у колонки эталонной цены */
	get photoShowsProductRecognized(): boolean {
		return this.hasColumnInCatalog('expectedPrice');
	}

	get usesPlanExpectedPrice(): boolean {
		return this.hasColumnInCatalog('expectedPrice');
	}

	get usesProductPlan(): boolean {
		return this.hasColumnInCatalog('ourProduct');
	}

	get needsPlan(): boolean {
		return this.usesPlanExpectedPrice || (this.showsMissingRows && this.usesProductPlan);
	}

	get isPriceCheckerEnabled(): boolean {
		if (this.task !== null && this.task.isPriceCheckerEnabled === true) {
			return true;
		}

		for (let i = 0; i < this.rows.length; i += 1) {
			const result = this.rows[i].result;
			const records = result && Array.isArray(result.priceCheckerRecords)
				? result.priceCheckerRecords
				: [];

			if (records.length > 0) {
				return true;
			}
		}

		return false;
	}

	get keyPrefix(): string {
		return KEY;
	}

	get photosKeyPrefix(): string {
		return PHOTOS_KEY;
	}

	fieldControlId(field: string): string {
		return 'sm-mobilemon-results-table-' + field + '-control-' + String((this as any)._uid);
	}

	get dash(): string {
		return MM_EMPTY_DASH;
	}

	get outcomeLegend(): MmBadgeEntry[] {
		return listDomainEntries('outcome');
	}

	get isBusyOverall(): boolean {
		return this.isSummaryLoading || this.isBulkBusy;
	}

	get isSelectionDisabled(): boolean {
		return this.isBulkBusy;
	}

	get busyFilterReason(): string {
		if (this.isSummaryLoading) {
			return this.$t(KEY + 'columnsSetupBusy') as string;
		}

		if (this.isBulkBusy) {
			return this.$t(KEY + 'actionBusy') as string;
		}

		return '';
	}

	get selectionBlockedReason(): string {
		return this.isSelectionDisabled ? (this.$t(KEY + 'actionBusy') as string) : '';
	}

	rowSelectBlockedReason(row: MmResultRow): string {
		if (row.isMissing) {
			return this.$t(KEY + 'rowNotSelectable') as string;
		}

		return this.selectionBlockedReason;
	}

	get emptyRowsTitle(): string {
		return this.$t(KEY + 'empty') as string;
	}

	private hasColumnInCatalog(key: string): boolean {
		const specs = this.columnCatalog;

		for (let i = 0; i < specs.length; i += 1) {
			if (specs[i].key === key) {
				return true;
			}
		}

		return false;
	}

	/** Ant 1.7.8 игнорирует fixed у колонок, пока таблице не задан scroll.x */
	get resultColumns(): any[] {
		const specs = this.columnCatalog;
		const columns: any[] = [];
		const pinContentKey = this.resolveLeftPinnedContentKey();

		if (this.isBulkReviewAllowed) {
			const checkColumn: any = {
				key: 'resultCheck',
				className: 'sm-mobilemon__res-check',
				width: 46,
				fixed: 'left',
				scopedSlots: { title: 'commonCheckbox', customRender: 'resultCheckboxCell' },
			};

			columns.push(checkColumn);
		}

		for (let i = 0; i < specs.length; i += 1) {
			const spec = specs[i];

			if (!this.isColumnVisible(spec.key)) {
				continue;
			}

			/** Заголовки колонок через слот: у th стоит nowrap без обрезки, и текст вылезал на соседнюю колонку */
			const column: any = {
				key: spec.key,
				scopedSlots: { customRender: spec.slot },
			};

			if (spec.key !== 'actions') {
				column.slots = { title: spec.key + 'ColumnTitle' };
				column.slotColumnTitleData = { text: this.$t(spec.titleKey) as string };
			} else {
				column.title = this.$t(spec.titleKey) as string;
			}

			column.width = spec.width !== null ? spec.width : MM_RESULT_COLUMN_AUTO_WIDTH;

			if (spec.sortable) {
				// Без функции сравнения сортировка остаётся серверной, иначе ant пересортирует страницу
				column.sorter = true;
				column.sortOrder = this.readSortOrder(spec.key);
			}

			/** У колонки исхода slots.title снимаем: он затёр бы легенду из scopedSlots.title */
			if (spec.key === 'outcome') {
				column.scopedSlots = { title: 'outcomeTitleSlot', customRender: spec.slot };
				delete column.slots;
				delete column.slotColumnTitleData;
			}

			if (spec.key === 'ourProduct') {
				column.className = 'sm-mobilemon__res-split';
			}

			if (spec.key === 'review') {
				column.className = 'sm-mobilemon__res-review-col';
			}

			if (spec.key === 'actions') {
				column.fixed = 'right';
			}

			if (pinContentKey !== null && spec.key === pinContentKey && spec.key !== 'actions') {
				column.fixed = 'left';
			}

			columns.push(column);
		}

		this.pickElasticColumn(columns);

		return columns;
	}

	private resolveLeftPinnedContentKey(): string | null {
		const pinOrder = ['ourProduct', 'tpcSubcategory', 'classification', 'productName'];

		for (let i = 0; i < pinOrder.length; i += 1) {
			const key = pinOrder[i];

			if (this.isColumnVisible(key)) {
				return key;
			}
		}

		return null;
	}

	/** Одна колонка без явной ширины забирает избыток: иначе за закреплённой колонкой открывается щель */
	private pickElasticColumn(columns: any[]): void {
		let bestIndex = -1;
		let bestWidth = -1;

		for (let i = 0; i < columns.length; i += 1) {
			const column = columns[i];

			if (column.fixed !== undefined || column.key === 'actions' || column.key === 'resultCheck') {
				continue;
			}

			const width = typeof column.width === 'number' ? column.width : 0;

			// Строго больше: при равенстве побеждает первая по порядку колонка
			if (width > bestWidth) {
				bestWidth = width;
				bestIndex = i;
			}
		}

		if (bestIndex >= 0) {
			delete columns[bestIndex].width;
		}
	}

	/** scrollX задаёт минимальную ширину, поэтому резиновая колонка входит каталожной шириной */
	get resultScrollX(): number {
		const specs = this.columnCatalog;
		// 46 — ширина колонки чекбоксов: без массового разбора её нет и в общую ширину она не входит
		let total = this.isBulkReviewAllowed ? 46 : 0;

		for (let i = 0; i < specs.length; i += 1) {
			if (!this.isColumnVisible(specs[i].key)) {
				continue;
			}

			total += specs[i].width !== null ? (specs[i].width as number) : MM_RESULT_COLUMN_AUTO_WIDTH;
		}

		return total;
	}

	isColumnVisible(key: string): boolean {
		return this.visibleColumnKeys.indexOf(key) >= 0;
	}

	get columnsButtonLabel(): string {
		return this.$t(KEY + 'columnsSetup') as string;
	}

	get priceCheckerButtonLabel(): string {
		return this.$t(KEY + 'priceCheckerTitle') as string;
	}

	get columnsButtonHint(): string {
		return this.isBusyOverall
			? (this.$t(KEY + 'columnsSetupBusy') as string)
			: this.columnsButtonLabel;
	}

	/** Проверка продублирована: состав колонок приходит и из sessionStorage, где мог устареть */
	handleColumnToggle(key: string, checked: boolean): void {
		const specs = this.columnCatalog;
		let toggleable = false;

		for (let i = 0; i < specs.length; i += 1) {
			if (specs[i].key === key) {
				toggleable = specs[i].toggleable;
			}
		}

		if (!toggleable) {
			return;
		}

		const index = this.visibleColumnKeys.indexOf(key);

		if (checked && index < 0) {
			this.visibleColumnKeys = this.visibleColumnKeys.concat([key]);
		}

		if (!checked && index >= 0) {
			const next = this.visibleColumnKeys.slice();

			next.splice(index, 1);
			this.visibleColumnKeys = next;
		}

		this.persistViewState();
	}

	private readSortOrder(field: string): string | boolean {
		if (this.sorting.field !== field || this.sorting.order === null) {
			return false;
		}

		return this.sorting.order === 'desc' ? 'descend' : 'ascend';
	}

	private resolveLevel(): string {
		const explicit = this.monitoringLevel !== '' ? this.monitoringLevel : null;
		const classifications = this.task !== null && this.task.classifications ? this.task.classifications : [];

		return resolveTaskMonitoringLevel(explicit, classifications);
	}

	/* Счётчики сводки считаются по полным серверным агрегатам, а не по загруженной странице */

	get summaryCounters(): MmResultNodeCounters {
		const counters = this.createEmptyCounters();

		for (let i = 0; i < this.aggregates.length; i += 1) {
			this.mergeCounters(counters, this.aggregates[i]);
		}

		if (this.aggregates.length === 0) {
			counters.positionsTotal = this.resultsTotal;
		}

		return counters;
	}

	get hasServerCounters(): boolean {
		return this.aggregates.length > 0;
	}

	get summaryUnitsTotal(): number {
		return this.aggregates.length;
	}

	get summaryUnitsWithData(): number {
		let count = 0;

		for (let i = 0; i < this.aggregates.length; i += 1) {
			if (this.aggregates[i].positionsTotal > 0) {
				count += 1;
			}
		}

		return count;
	}

	get summaryClassifications(): MmTaskClassification[] {
		const result: MmTaskClassification[] = [];

		for (let i = 0; i < this.aggregates.length; i += 1) {
			const classification = this.aggregates[i].classification;

			if (classification) {
				result.push(classification);
			}
		}

		return result;
	}

	get isSummaryVisible(): boolean {
		return this.summaryChips.length > 0;
	}

	/** Счётчик, которого сервер не прислал, прячем; ноль — значимое значение и показывается */
	get summaryChips(): MmCounterChip[] {
		const counters = this.summaryCounters;

		if (!this.hasServerCounters) {
			if (counters.positionsTotal === 0) {
				return [];
			}

			return [
				{
					key: 'positions',
					label: this.$t(KEY + 'positions') as string,
					value: String(counters.positionsTotal),
					tone: 'neutral',
				},
			];
		}

		const chips: MmCounterChip[] = [
			{
				key: 'captured',
				label: this.$t(KEY + 'groupCaptured') as string,
				value: String(counters.positionsWithPrice) + ' / ' + String(counters.positionsTotal),
				tone: 'success',
			},
		];

		this.pushChip(chips, 'notFound', KEY + 'groupNotFound', counters.positionsNotFound, 'warning');
		this.pushChip(chips, 'skipped', KEY + 'groupSkipped', counters.positionsSkipped, 'warning');
		this.pushChip(
			chips,
			'priceNotRecognized',
			KEY + 'groupPriceNotRecognized',
			counters.positionsPriceNotRecognized,
			'attention',
		);
		this.pushChip(chips, 'unspecified', KEY + 'groupUnspecified', counters.positionsUnspecified, 'danger');
		this.pushChip(chips, 'photos', KEY + 'groupPhotos', counters.photosTotal, 'neutral');

		return chips;
	}

	private pushChip(
		target: MmCounterChip[],
		key: string,
		labelKey: string,
		value: number | null | undefined,
		tone: string,
	): void {
		if (value === null || value === undefined) {
			return;
		}

		target.push({
			key: key,
			label: this.$t(labelKey) as string,
			value: String(value),
			tone: tone,
		});
	}

	/** Числа нет — пустая строка, а не прочерк: «Приёмка —» читалось бы как сбой */
	get summaryReview(): string {
		if (!this.hasServerCounters) {
			return '';
		}

		if (this.levelIsRowKey) {
			return this.$t(KEY + 'groupReview', {
				done: this.summaryUnitsWithData,
				total: this.summaryUnitsTotal,
			}) as string;
		}

		const counters = this.summaryCounters;
		const reviewed = counters.positionsReviewed;

		if (reviewed === null) {
			return '';
		}

		return this.$t(KEY + 'groupReview', { done: reviewed, total: counters.positionsTotal }) as string;
	}

	get summaryPriceRange(): string {
		const counters = this.summaryCounters;
		const min = counters.priceMin;
		const max = counters.priceMax;

		if (min === null || max === null) {
			return '';
		}

		return this.$t(KEY + 'groupPriceRange', { min: formatMoney(min), max: formatMoney(max) }) as string;
	}

	private readClassificationTitle(classification: MmTaskClassification): string {
		if (classification.subcategoryName) {
			return String(classification.subcategoryName);
		}

		if (classification.categoryName) {
			return String(classification.categoryName);
		}

		return orDash(classification.groupName);
	}

	private createEmptyCounters(): MmResultNodeCounters {
		return {
			positionsTotal: 0,
			positionsWithPrice: 0,
			positionsPending: 0,
			positionsNotFound: null,
			positionsSkipped: null,
			positionsPriceNotRecognized: null,
			positionsUnspecified: null,
			positionsReviewed: null,
			photosTotal: null,
			priceMin: null,
			priceMax: null,
		};
	}

	/** null у необязательного счётчика значит «сервер не прислал», а не ноль, поэтому сумма остаётся null */
	private mergeCounters(target: MmResultNodeCounters, source: MmResultGroupAggregate): void {
		target.positionsTotal += source.positionsTotal ? source.positionsTotal : 0;
		target.positionsWithPrice += source.positionsWithPrice ? source.positionsWithPrice : 0;
		target.positionsPending += source.positionsPending ? source.positionsPending : 0;

		target.positionsNotFound = this.addNullable(target.positionsNotFound, source.positionsNotFound);
		target.positionsSkipped = this.addNullable(target.positionsSkipped, source.positionsSkipped);
		target.positionsPriceNotRecognized = this.addNullable(
			target.positionsPriceNotRecognized,
			source.positionsPriceNotRecognized,
		);
		target.positionsUnspecified = this.addNullable(target.positionsUnspecified, source.positionsUnspecified);
		target.positionsReviewed = this.addNullable(target.positionsReviewed, source.positionsReviewed);
		target.photosTotal = this.addNullable(target.photosTotal, source.photosTotal);

		target.priceMin = this.minNullable(target.priceMin, source.priceMin);
		target.priceMax = this.maxNullable(target.priceMax, source.priceMax);
	}

	private addNullable(current: number | null, next: number | null | undefined): number | null {
		if (next === null || next === undefined) {
			return current;
		}

		return (current === null ? 0 : current) + next;
	}

	private minNullable(current: number | null, next: number | null | undefined): number | null {
		if (next === null || next === undefined) {
			return current;
		}

		return current === null || next < current ? next : current;
	}

	private maxNullable(current: number | null, next: number | null | undefined): number | null {
		if (next === null || next === undefined) {
			return current;
		}

		return current === null || next > current ? next : current;
	}

	/** Считает сервер: на клиенте видна одна страница, и счётчики по ней были бы неверными */
	private loadSummary(): void {
		if (this.tradingId === null || this.task === null) {
			return;
		}

		if (this.isPhotoVisible) {
			this.needsReload = true;

			return;
		}

		if (!this.isActive) {
			this.needsReload = true;

			return;
		}

		this.cancelSummaryRequest();

		const source = createCancelSource();

		this.summarySource = source;
		this.isSummaryLoading = true;

		this.loadGroupsFromContext({ cancelToken: source.token, params: this.buildQuickFilters() })
			.then((data) => {
				if (this.summarySource !== source) {
					return;
				}

				this.aggregates = Array.isArray(data.items) ? data.items : [];
				this.monitoringLevel = data.monitoringLevel ? String(data.monitoringLevel) : '';
				this.resultsTotal = typeof data.resultsTotal === 'number' ? data.resultsTotal : this.sumPositions();
				this.resultsUnspecifiedTotal =
					typeof data.resultsUnspecifiedTotal === 'number' ? data.resultsUnspecifiedTotal : null;
				this.loadError = null;
				this.hasLoadedSummary = true;

				this.loadRows(true).then(() => {
					this.applyPendingHighlight();
				});

				this.$emit('results-total', this.resultsTotal);
			})
			.catch((error) => {
				if (isCanceled(error) || this.summarySource !== source) {
					return;
				}

				this.aggregates = [];
				this.resultsTotal = 0;
				this.resultsUnspecifiedTotal = null;
				/** Событие шлём и при отказе: счётчик в родителе обновляется только им и завис бы на старом числе */
				this.$emit('results-total', 0);
				this.loadError = readMmError(error, SECTION_GROUPS);
			})
			.finally(() => {
				if (this.summarySource !== source) {
					return;
				}

				this.summarySource = null;
				this.isSummaryLoading = false;
			});
	}

	/** Отказ плана не роняет таблицу: колонка эталона покажет прочерк, loadError не трогаем */
	private loadPlan(): void {
		if (!this.needsPlan || this.task === null) {
			return;
		}

		if (this.isPhotoVisible) {
			this.needsReload = true;

			return;
		}

		if (!this.isActive) {
			this.needsReload = true;

			return;
		}

		this.cancelPlanRequest();

		const source = createCancelSource();

		this.planSource = source;

		this.loadPlanForTasks(source, this.planTaskIds, 0, {})
			.then((map) => {
				if (this.planSource !== source) {
					return;
				}

				this.planItems = map;
				this.appendMissingRowsToLoadedList();
			})
			.catch((error) => {
				if (isCanceled(error) || this.planSource !== source) {
					return;
				}

				this.planItems = {};
			})
			.finally(() => {
				if (this.planSource === source) {
					this.planSource = null;
				}
			});
	}

	private loadPlanPage(
		source: any,
		planTaskId: string,
		page: number,
		collected: { [key: string]: MmTaskItem },
	): Promise<{ [key: string]: MmTaskItem }> {
		const pagination: MmPaginationState = { current: page, pageSize: PLAN_PAGE_SIZE, total: 0 };

		return fetchTaskItems(planTaskId, buildPageQuery(pagination), { cancelToken: source.token }).then((result) => {
			const content = result && result.content ? result.content : [];

			for (let i = 0; i < content.length; i += 1) {
				collected[String(content[i].id)] = content[i];
			}

			/** Наличие следующей страницы решает hasNextPage: без total арифметика обрывала дочитывание */
			const hasNext = result !== null && result !== undefined && hasNextPage(result, pagination);

			if (content.length > 0 && page < PLAN_MAX_PAGES && hasNext) {
				return this.loadPlanPage(source, planTaskId, page + 1, collected);
			}

			return collected;
		});
	}

	private get planTaskIds(): string[] {
		const fromContext = this.ctx.planTaskIds;

		if (fromContext !== null && fromContext.length > 0) {
			return fromContext.slice(0, PLAN_MAX_TASKS);
		}

		return this.taskId ? [this.taskId] : [];
	}

	/** Планы читаем по одному заданию, чтобы не занять очередь запросов; отказ по одному не критичен */
	private loadPlanForTasks(
		source: any,
		ids: string[],
		index: number,
		collected: { [key: string]: MmTaskItem },
	): Promise<{ [key: string]: MmTaskItem }> {
		if (index >= ids.length) {
			return Promise.resolve(collected);
		}

		return this.loadPlanPage(source, ids[index], 1, collected)
			.catch((error) => {
				if (isCanceled(error)) {
					throw error;
				}

				return collected;
			})
			.then((map) => {
				if (this.planSource !== source) {
					return map;
				}

				return this.loadPlanForTasks(source, ids, index + 1, map);
			});
	}

	private appendMissingRowsToLoadedList(): void {
		if (!this.showsMissingRows || !this.usesProductPlan) {
			return;
		}

		if (this.listStatus !== 'loaded' || this.listPagination.current !== 1) {
			return;
		}

		const results: MmMonitoringResult[] = [];

		for (let i = 0; i < this.rows.length; i += 1) {
			const result = this.rows[i].result;

			if (result !== null) {
				results.push(result);
			}
		}

		this.rows = this.buildRows(results, 1, this.listPagination.total);
	}

	private sumPositions(): number {
		let total = 0;

		for (let i = 0; i < this.aggregates.length; i += 1) {
			total += this.aggregates[i].positionsTotal ? this.aggregates[i].positionsTotal : 0;
		}

		return total;
	}

	/** taskIds уходит всегда: запрос глобальный, иначе в карточку попадут чужие позиции */
	private loadRows(resetPage: boolean): Promise<void> {
		if (this.tradingId === null) {
			return Promise.resolve();
		}

		if (this.isPhotoVisible) {
			this.needsReload = true;

			return Promise.resolve();
		}

		this.cancelListRequest();

		const pagination = this.ensureListPagination(resetPage);
		const source = createCancelSource();

		this.listSource = source;
		this.listStatus = 'loading';
		this.listError = null;

		return this.loadResultsFromContext(
			this.buildListFilters(),
			buildPageQuery(pagination, this.sorting),
			{ cancelToken: source.token },
		)
			.then((page) => {
				if (this.listSource !== source) {
					return;
				}

				const content = page && page.content ? page.content : [];
				const total = page ? page.totalElements : 0;

				this.listPagination = {
					current: pagination.current,
					pageSize: pagination.pageSize,
					total: total,
				};
				this.rows = this.buildRows(content, pagination.current, total);
				this.refreshPhotoQueueFromRows();
				this.listStatus = 'loaded';
				this.hasLoadedRows = true;
				this.ensurePriceCheckerColumn();
			})
			.catch((error) => {
				if (isCanceled(error) || this.listSource !== source) {
					return;
				}

				/** Строки гасим, а сводку нет: это другой запрос, его счётчики отказом списка не опровергнуты */
				this.rows = [];
				this.listError = readMmError(error, SECTION_LIST);
				this.listStatus = 'error';
			})
			.finally(() => {
				if (this.listSource === source) {
					this.listSource = null;
				}
			});
	}

	private buildQuickFilters(): Partial<MmResultListFilters> {
		return {
			onlyLatest: this.onlyLatest,
			onlyUnspecifiedOutcome: this.onlyUnspecifiedOutcome,
			onlyAnalogs: this.onlyAnalogs,
		};
	}

	/** Свободная карта, а не тип фильтров: части полей в контракте нет, приведение скрыло бы проверку */
	private buildListFilters(): { [key: string]: any } {
		return Object.assign({ taskIds: [this.taskId] }, this.buildQuickFilters());
	}

	private ensureListPagination(resetPage: boolean): MmPaginationState {
		if (resetPage) {
			this.listPagination = createPaginationState(GROUP_PAGE_SIZE);
		}

		return this.listPagination;
	}

	/** Смена страницы выбор не сбрасывает; смена сортировки возвращает на первую страницу */
	handleListTableChange(event: MmTableChangePayload): void {
		if (!event) {
			return;
		}

		const sorterChanged = event.sorter.field !== this.sorting.field || event.sorter.order !== this.sorting.order;

		this.listPagination = event.pagination;

		if (sorterChanged) {
			this.sorting = event.sorter;
			this.loadRows(true);

			return;
		}

		this.loadRows(false);
	}

	handleListRetry(): void {
		this.loadRows(false);
	}

	/** Строки «Не выполнено» достраиваются только на первой странице: сервер отдаёт результаты страницами */
	private buildRows(
		results: MmMonitoringResult[],
		page: number,
		total: number,
	): MmResultRow[] {
		const rows: MmResultRow[] = [];
		const duplicateKeys: { [key: string]: number } = {};
		const captures: { [key: string]: { count: number; latestAt: string; latestIndex: number } } = {};

		for (let i = 0; i < results.length; i += 1) {
			const result = results[i];
			const classificationId = result.taskClassificationId ? String(result.taskClassificationId) : '';
			const code = this.readDuplicateKey(result);

			if (code !== '') {
				const seen = duplicateKeys[code];

				duplicateKeys[code] = (seen ? seen : 0) + 1;
			}

			this.trackCapture(captures, result, rows.length);

			rows.push({
				key: 'r:' + String(result.id),
				result: result,
				classification: this.findClassification(classificationId),
				planItem: null,
				isMissing: false,
				isDuplicate: false,
				extraCaptures: 0,
			});
		}

		// Дубли ищем вторым проходом: на первом ещё не известно, повторится ли штрих-код дальше
		if (this.detectsDuplicates) {
			for (let i = 0; i < rows.length; i += 1) {
				const code = this.readDuplicateKey(rows[i].result);

				rows[i].isDuplicate = code !== '' && duplicateKeys[code] > 1;
			}
		}

		this.markExtraCaptures(rows, captures);

		if (page !== 1) {
			return rows;
		}

		this.appendMissingLevelRows(rows);

		if (!this.showsMissingRows) {
			return rows;
		}

		this.appendMissingPlanRows(rows, results, total);

		return rows;
	}

	private appendMissingLevelRows(rows: MmResultRow[]): void {
		if (this.onlyUnspecifiedOutcome || this.onlyAnalogs || this.hasNarrowingScopeFilters()) {
			return;
		}

		for (let i = 0; i < this.aggregates.length; i += 1) {
			const aggregate = this.aggregates[i];
			const classification = aggregate.classification;
			const id = classification && classification.id ? String(classification.id) : '';

			if (id === '' || aggregate.positionsTotal > 0) {
				continue;
			}

			rows.push({
				key: 'm:' + id,
				result: null,
				classification: classification,
				planItem: null,
				isMissing: true,
				isDuplicate: false,
				extraCaptures: 0,
			});
		}
	}

	private appendMissingPlanRows(
		rows: MmResultRow[],
		results: MmMonitoringResult[],
		total: number,
	): void {
		if (!this.usesProductPlan || !this.canDetectMissingPlanRows(results, total)) {
			return;
		}

		const covered: { [key: string]: boolean } = {};

		for (let i = 0; i < results.length; i += 1) {
			const link = results[i].taskProductId;

			if (link !== null && link !== undefined) {
				covered[String(link)] = true;
			}
		}

		const ids = Object.keys(this.planItems);

		for (let i = 0; i < ids.length; i += 1) {
			const item = this.planItems[ids[i]];

			if (!item || covered[ids[i]] === true) {
				continue;
			}

			// Позиции, привязанные к карточке уровня, уже добавлены циклом выше — иначе задвоятся
			if (item.classificationId !== null && item.classificationId !== undefined) {
				continue;
			}

			rows.push({
				key: 'p:' + ids[i],
				result: null,
				classification: null,
				planItem: item,
				isMissing: true,
				isDuplicate: false,
				extraCaptures: 0,
			});
		}
	}

	private canDetectMissingPlanRows(results: MmMonitoringResult[], total: number): boolean {
		if (this.onlyUnspecifiedOutcome || this.onlyAnalogs || this.hasNarrowingScopeFilters()) {
			return false;
		}

		return total <= results.length;
	}

	/** Повторяет ключ дедупликации сервера, иначе подпись «ещё N съёмок» разойдётся с фильтром */
	private readDuplicateKey(result: MmMonitoringResult | null): string {
		const code = this.readRawField(result, 'barCode');

		if (code === '' || result === null) {
			return '';
		}

		return String(result.taskId) + '|' + code;
	}

	private readCaptureKey(result: MmMonitoringResult): string {
		let position = String(result.id);

		if (result.competitorProductName !== null && result.competitorProductName !== undefined) {
			position = String(result.competitorProductName);
		}

		if (result.taskProductId !== null && result.taskProductId !== undefined) {
			position = String(result.taskProductId);
		}

		return String(result.taskClassificationId) + '|' + position;
	}

	private trackCapture(
		captures: { [key: string]: { count: number; latestAt: string; latestIndex: number } },
		result: MmMonitoringResult,
		index: number,
	): void {
		const key = this.readCaptureKey(result);
		// Строки ISO сравниваются посимвольно верно, разбор в Date здесь не нужен
		const capturedAt = result.capturedAt === null || result.capturedAt === undefined
			? ''
			: String(result.capturedAt);
		const current = captures[key];

		if (!current) {
			captures[key] = { count: 1, latestAt: capturedAt, latestIndex: index };

			return;
		}

		current.count += 1;

		if (capturedAt > current.latestAt) {
			current.latestAt = capturedAt;
			current.latestIndex = index;
		}
	}

	private markExtraCaptures(
		rows: MmResultRow[],
		captures: { [key: string]: { count: number; latestAt: string; latestIndex: number } },
	): void {
		const keys = Object.keys(captures);

		for (let i = 0; i < keys.length; i += 1) {
			const entry = captures[keys[i]];

			if (entry.count > 1 && rows[entry.latestIndex]) {
				rows[entry.latestIndex].extraCaptures = entry.count - 1;
			}
		}
	}

	private findClassification(classificationId: string): MmTaskClassification | null {
		if (classificationId === '') {
			return null;
		}

		const classifications = this.summaryClassifications;

		for (let i = 0; i < classifications.length; i += 1) {
			if (String(classifications[i].id) === classificationId) {
				return classifications[i];
			}
		}

		return null;
	}

	get isListSkeletonVisible(): boolean {
		return this.listStatus === 'loading' && !this.hasLoadedRows;
	}

	get listErrorText(): string {
		const error = this.listError;
		const message = error && error.message ? String(error.message).trim() : '';

		return message !== '' ? message : (this.$t(KEY + 'loadErrorHint') as string);
	}

	get listErrorDiagnostics(): string {
		return this.listError ? formatDiagnostics(this.listError.diagnostics) : '';
	}

	get isListErrorRetryable(): boolean {
		return this.listError ? this.listError.retryable : false;
	}

	get listPaginationOrNull(): MmPaginationState | null {
		const pagination = this.listPagination;

		return pagination.total <= pagination.pageSize ? null : pagination;
	}

	get selectionIndex(): MmSelectionIndex {
		return buildSelectionIndex(this.selection, keyOfResultId);
	}

	get selectedResultsCount(): number {
		return selectedCount(this.selection, this.resultsTotal);
	}

	get isBulkBarVisible(): boolean {
		return this.isBulkReviewAllowed && this.selectedResultsCount > 0;
	}

	private buildExtensionContext(): MmTaskCardExtensionContext {
		return {
			taskId: this.taskId,
			batchId: this.ctx.batchId,
			task: this.task,
			taskType: this.taskType,
			monitoringLevel: this.resolveLevel() as MmMonitoringLevel,
			tradingNetworkId: this.tradingId,
			reload: this.reload,
		};
	}

	get bulkBarPayload(): MmTaskResultsBulkBarPayload {
		return Object.assign(this.buildExtensionContext(), {
			selection: this.selection,
			selectedCount: this.selectedResultsCount,
			total: this.resultsTotal,
			filters: this.buildReviewFilters(),
			sorting: this.sorting,
			pagination: {
				current: this.listPagination.current,
				pageSize: this.listPagination.pageSize,
				total: this.resultsTotal,
			},
			busy: this.isBulkBusy,
		});
	}

	buildRowActionsPayload(row: MmResultRow, index: number): MmTaskResultsRowActionsPayload {
		return Object.assign(this.buildExtensionContext(), {
			/** Приведение законно: на строках «Не выполнено» блок не рендерится, у остальных результат есть */
			result: row.result as MmMonitoringResult,
			index: index,
			outcome: this.readOutcome(row),
		});
	}

	isRowChecked(row: MmResultRow): boolean {
		if (row.result === null) {
			return false;
		}

		return isRowSelected(this.selection, this.selectionIndex, String(row.result.id));
	}

	handleRowChecked(row: MmResultRow, checked: boolean): void {
		if (row.result === null) {
			return;
		}

		const key = String(row.result.id);

		toggleRow(this.selection, this.selectionIndex, key, key, checked, keyOfResultId);
	}

	/** Режим здесь не трогаем: его уже переключил v-model, наше дело — очистить оба массива */
	handleCommonCheckboxChange(): void {
		resetSelectionArrays(this.selection);
	}

	handleClearSelection(): void {
		resetSelection(this.selection);
	}

	private confirmSelectionReset(apply: () => void): void {
		if (isSelectionEmpty(this.selection)) {
			apply();

			return;
		}

		AntModal.confirm({
			title: this.$t(KEY + 'confirmSelectionReset', { count: this.selectedResultsCount }) as string,
			okText: this.$t('shared.actions.ok') as string,
			cancelText: this.$t('shared.actions.cancel') as string,
			onOk: () => {
				resetSelection(this.selection);
				apply();
			},
		});
	}

	handleQuickFilterDraft(name: string, checked: boolean): void {
		this.setQuickFilterDraft(name, checked);
	}

	private setQuickFilterDraft(name: string, checked: boolean): void {
		if (name === 'onlyAnalogs') {
			this.draftOnlyAnalogs = checked;
		}

		if (name === 'onlyUnspecifiedOutcome') {
			this.draftOnlyUnspecifiedOutcome = checked;
		}

		if (name === 'onlyLatest') {
			this.draftOnlyLatest = checked;
		}
	}

	private commitQuickFiltersFromDraft(): void {
		this.onlyAnalogs = this.draftOnlyAnalogs;
		this.onlyUnspecifiedOutcome = this.draftOnlyUnspecifiedOutcome;
		this.onlyLatest = this.draftOnlyLatest;
	}

	private syncQuickFilterDraftFromApplied(): void {
		this.draftOnlyAnalogs = this.onlyAnalogs;
		this.draftOnlyUnspecifiedOutcome = this.onlyUnspecifiedOutcome;
		this.draftOnlyLatest = this.onlyLatest;
	}

	handleRefresh(): void {
		if (!this.hasPendingQuickFilterChanges) {
			this.reload();

			return;
		}

		this.confirmSelectionReset(() => {
			this.commitQuickFiltersFromDraft();
			this.persistViewState();
			this.reload();
		});
	}

	get acceptBlockedReasonKey(): string {
		const scopeKey = this.ctx.scopeBlockedReasonKey;

		if (scopeKey !== null && scopeKey !== undefined && scopeKey !== '') {
			return scopeKey;
		}

		return this.isDeliveryIncomplete() ? KEY + 'bulkDisabledDelivery' : '';
	}

	private isScopeAcceptBlocked(): boolean {
		const key = this.ctx.scopeBlockedReasonKey;

		return key !== null && key !== undefined && key !== '';
	}

	private isDeliveryIncomplete(): boolean {
		if (this.isScopeAcceptBlocked()) {
			return true;
		}

		// Флага ещё нет в типе задания, поэтому читаем его как необязательное поле ответа
		const source: any = this.task;

		if (!source) {
			return false;
		}

		if (source.isPartiallyDelivered === true) {
			return true;
		}

		return source.isDeliveryComplete === false;
	}

	get canCorrectSelected(): boolean {
		return this.findFirstSelectedEditableRow() !== null;
	}

	private findFirstSelectedEditableRow(): MmResultRow | null {
		for (let i = 0; i < this.rows.length; i += 1) {
			if (this.isRowChecked(this.rows[i]) && this.canEditPrice(this.rows[i])) {
				return this.rows[i];
			}
		}

		return null;
	}

	handleBulkAccept(): void {
		this.runBulkAction('accept', '');
	}

	handleBulkReject(comment: string): void {
		this.runBulkAction('reject', comment);
	}

	handleBulkDelete(): void {
		this.runBulkAction('delete', '');
	}

	handleBulkCorrect(): void {
		const found = this.findFirstSelectedEditableRow();

		if (found === null) {
			return;
		}

		this.startEdit(found);
	}

	private runBulkAction(action: MmBulkReviewAction, comment: string): void {
		this.submitReview(action, comment, buildSelectCheckBoxesData(this.selection, MM_RESULT_SELECTION_FIELDS), true);
	}

	private submitReview(
		action: MmBulkReviewAction,
		comment: string,
		selectData: { [key: string]: any },
		resetAfterSuccess: boolean,
	): void {
		this.isBulkBusy = true;

		const submitter = this.ctx.submitReview;
		const request = submitter !== null && submitter !== undefined
			? submitter(action, this.buildReviewFilters(), selectData as any, comment)
			: bulkReviewResults(
				this.taskId,
				action,
				this.buildReviewFilters(),
				selectData as any,
				comment,
			);

		request
			.then((response) => {
				const affected = response && response.data && typeof response.data.affected === 'number'
					? response.data.affected
					: this.selectedResultsCount;

				this.applyReviewStatusPatch(action, selectData);

				this.showInfo(this.$t(KEY + 'bulkSuccess', { count: affected }) as string);

				if (resetAfterSuccess) {
					resetSelection(this.selection);
				}

				this.notifyBulkBar(true);
				this.closeRowReject();

				if (this.shouldAdvancePhotoAfterReview(action, selectData)) {
					this.advancePhotoAfterDecision();
				}

				if (this.isPhotoVisible) {
					this.needsReload = true;
				} else {
					this.loadSummary();
					this.notifyReviewComplete();
				}
			})
			.catch((error) => {
				if (isCanceled(error)) {
					return;
				}

				const mmError = readMmError(error, 'results/bulk-review');
				const message = mmError.message ? String(mmError.message) : '';

				this.showError(
					message !== '' ? message : (this.$t(KEY + 'bulkError') as string),
				);
				this.notifyBulkBar(false);
			})
			.finally(() => {
				this.isBulkBusy = false;
			});
	}

	private notifyReviewComplete(): void {
		const handler = this.ctx.onReviewComplete;

		if (handler !== null && handler !== undefined) {
			handler();
		}
	}

	buildReviewFilters(): Partial<MmResultListFilters> {
		/** null в области означает одно задание, а не «фильтров нет» */
		const scopeFilters = this.ctx.scopeFilters;
		const scope: { [key: string]: any } = scopeFilters !== null && scopeFilters !== undefined
			? Object.assign({}, scopeFilters)
			: { taskIds: [this.taskId] };

		/** Область кладётся поверх быстрых фильтров: обратный порядок развёл бы показ и массовую операцию */
		return Object.assign({}, this.buildQuickFilters(), scope);
	}

	private notifyBulkBar(success: boolean): void {
		const bar: any = this.$refs.bulkBar;

		if (bar && typeof bar.finishAction === 'function') {
			bar.finishAction(success);
		}
	}

	canReviewRow(row: MmResultRow): boolean {
		return row.result !== null
			&& !this.isDeliveryIncomplete()
			&& !this.isBulkBusy
			&& this.isReviewPending(row);
	}

	isReviewPending(row: MmResultRow): boolean {
		return this.readReviewStatus(row) === MmReviewStatus.PENDING;
	}

	private applyReviewStatusPatch(action: MmBulkReviewAction, selectData: { [key: string]: any }): void {
		if (action !== 'accept' && action !== 'reject') {
			return;
		}

		const included = selectData[MM_RESULT_SELECTION_FIELDS.included];

		if (!Array.isArray(included) || included.length === 0) {
			return;
		}

		const newStatus = action === 'accept' ? MmReviewStatus.ACCEPTED : MmReviewStatus.REJECTED;
		const idSet: { [key: string]: boolean } = {};

		for (let i = 0; i < included.length; i += 1) {
			idSet[String(included[i])] = true;
		}

		const nextRows = this.rows.slice();
		let changed = false;

		for (let i = 0; i < nextRows.length; i += 1) {
			const result = nextRows[i].result;

			if (result === null || !idSet[String(result.id)]) {
				continue;
			}

			nextRows[i] = {
				key: nextRows[i].key,
				result: Object.assign({}, result, { reviewStatus: newStatus }),
				classification: nextRows[i].classification,
				planItem: nextRows[i].planItem,
				isMissing: nextRows[i].isMissing,
				isDuplicate: nextRows[i].isDuplicate,
				extraCaptures: nextRows[i].extraCaptures,
			};
			changed = true;

			if (this.photoAnchorRow !== null && this.photoAnchorRow.key === nextRows[i].key) {
				this.photoAnchorRow = nextRows[i];
			}

			this.syncPhotoQueueRow(nextRows[i].key, nextRows[i]);
		}

		if (changed) {
			this.rows = nextRows;
		}
	}

	reviewBlockedReason(row: MmResultRow): string {
		if (this.canReviewRow(row)) {
			return '';
		}

		if (row.result === null) {
			return this.$t(KEY + 'actionNoResult') as string;
		}

		if (this.isDeliveryIncomplete()) {
			return this.$t(this.acceptBlockedReasonKey) as string;
		}

		if (row.result !== null && !this.isReviewPending(row)) {
			const status = this.readReviewStatus(row);

			if (status === MmReviewStatus.ACCEPTED || status === MmReviewStatus.PRICE_CORRECTED) {
				return this.$t(KEY + 'reviewAlreadyAccepted') as string;
			}

			if (status === MmReviewStatus.REJECTED) {
				return this.$t(KEY + 'reviewAlreadyRejected') as string;
			}
		}

		return this.$t(KEY + 'actionBusy') as string;
	}

	editBlockedReason(row: MmResultRow): string {
		if (this.canEditPrice(row)) {
			return '';
		}

		if (row.result === null) {
			return this.$t(KEY + 'actionNoResult') as string;
		}

		return this.$t(KEY + 'actionBusy') as string;
	}

	photoBlockedReason(row: MmResultRow): string {
		if (this.readPhotos(row).length > 0) {
			return '';
		}

		return this.$t('priceMonitoring.mobileMonitoring.photos.emptyHint') as string;
	}

	deleteBlockedReason(row: MmResultRow): string {
		return row.isMissing ? (this.$t(KEY + 'actionNoResult') as string) : '';
	}

	handleRowAction(row: MmResultRow, action: string): void {
		if (action === 'photo') {
			this.openPhotos(row, 0);

			return;
		}

		if (action === 'correct') {
			this.startEdit(row);

			return;
		}

		if (action === 'reject') {
			this.openRowReject(row);

			return;
		}

		if (row.result === null) {
			return;
		}

		if (action === 'accept') {
			this.submitSingle(row, 'accept', '');

			return;
		}

		if (action === 'delete') {
			AntModal.confirm({
				title: this.$t(KEY + 'confirmDeleteTitle') as string,
				content: this.$t(KEY + 'confirmDelete', { count: 1 }) as string
					+ ' ' + (this.$t(KEY + 'confirmDeleteIrreversible') as string),
				okText: this.$t('shared.actions.delete') as string,
				okType: 'danger',
				cancelText: this.$t('shared.actions.cancel') as string,
				onOk: () => {
					this.submitSingle(row, 'delete', '');
				},
			});
		}
	}

	private submitSingle(row: MmResultRow, action: MmBulkReviewAction, comment: string): void {
		if (row.result === null) {
			return;
		}

		const payload: { [key: string]: any } = {
			isCommonCheckboxSelected: false,
		};

		payload[MM_RESULT_SELECTION_FIELDS.included] = [String(row.result.id)];
		payload[MM_RESULT_SELECTION_FIELDS.excluded] = [];

		this.submitReview(action, comment, payload, false);
	}

	openRowReject(row: MmResultRow, inPhoto?: boolean): void {
		if (row.result === null) {
			return;
		}

		this.rejectRow = row;
		this.rejectInPhoto = inPhoto === true;
		this.rejectComment = '';
		this.rejectError = '';
	}

	handleRowRejectInput(event: any): void {
		const value = event && event.target ? event.target.value : '';

		this.rejectComment = value === null || value === undefined ? '' : String(value);

		if (this.rejectComment.trim() !== '') {
			this.rejectError = '';
		}
	}

	handleRowRejectSubmit(): void {
		if (this.rejectRow === null || this.isBulkBusy) {
			return;
		}

		if (this.rejectComment.trim() === '') {
			this.rejectError = this.$t(KEY + 'rejectCommentRequired') as string;

			return;
		}

		this.submitSingle(this.rejectRow, 'reject', this.rejectComment.trim());
	}

	handleRowRejectCancel(): void {
		if (this.isBulkBusy) {
			return;
		}

		this.closeRowReject();
	}

	/** Флаг места сбрасываем вместе со строкой: иначе следующее отклонение из таблицы не покажет форму */
	private closeRowReject(): void {
		this.rejectRow = null;
		this.rejectInPhoto = false;
		this.rejectComment = '';
		this.rejectError = '';
	}

	isEditing(row: MmResultRow): boolean {
		return this.editingRowKey === row.key;
	}

	isSavingRow(row: MmResultRow): boolean {
		return this.savingRowKey === row.key;
	}

	/** Условие обязано совпадать с проверкой в startEdit, иначе кнопка включена, а нажатие пустое */
	canEditPrice(row: MmResultRow): boolean {
		return row.result !== null && !this.isBulkBusy && this.savingRowKey === null;
	}

	handleStartEdit(row: MmResultRow): void {
		this.startEdit(row);
	}

	private startEdit(row: MmResultRow, focusRef?: string): void {
		if (this.savingRowKey !== null || !this.canEditPrice(row)) {
			return;
		}

		this.editRunId += 1;
		this.editingRowKey = row.key;
		this.editValue = this.readEditableValue(row);
		this.editError = '';

		const refName = focusRef !== undefined && focusRef !== '' ? focusRef : 'priceInput';

		this.$nextTick(() => {
			const input: any = this.$refs[refName];

			if (input && typeof input.focus === 'function') {
				input.focus();
			}
		});
	}

	private readEditableValue(row: MmResultRow): string {
		const result = row.result;

		if (result === null) {
			return '';
		}

		const corrected = this.readNumberField(result, 'correctedPrice');
		const value = corrected !== null ? corrected : this.readNumberField(result, 'price');

		return value === null ? '' : String(value);
	}

	handleEditInput(event: any): void {
		const value = event && event.target ? event.target.value : '';

		this.editValue = value === null || value === undefined ? '' : String(value);
		this.editError = this.validatePrice(this.editValue);
	}

	private validatePrice(raw: string): string {
		const text = String(raw).trim().replace(',', '.');

		if (text === '') {
			return this.$t(KEY + 'correctInvalid') as string;
		}

		if (!/^\d+(\.\d{1,2})?$/.test(text)) {
			return this.$t(KEY + 'correctInvalid') as string;
		}

		return Number(text) > 0 ? '' : (this.$t(KEY + 'correctInvalid') as string);
	}

	handleEditCancel(): void {
		this.exitEdit();
	}

	private exitEdit(): void {
		// Выход из правки двигает счётчик сессии: поздний ответ не вернёт редактор и не заберёт фокус
		this.editRunId += 1;
		this.editingRowKey = null;
		this.editValue = '';
		this.editError = '';
	}

	/** Значение после успеха берём из ответа сервера; при ошибке набранное остаётся в поле */
	handleEditSave(row: MmResultRow): void {
		if (row.result === null || this.savingRowKey !== null) {
			return;
		}

		const error = this.validatePrice(this.editValue);

		if (error !== '') {
			this.editError = error;

			return;
		}

		const runId = this.editRunId;
		const rowKey = row.key;
		const price = Number(String(this.editValue).trim().replace(',', '.'));

		this.savingRowKey = rowKey;

		correctResultPrice(String(row.result.id), price)
			.then((response) => {
				const updated = response && response.data ? response.data : null;

				if (updated !== null) {
					this.replaceRowResult(rowKey, updated);
				}

				this.showInfo(this.$t(KEY + 'correctSaved') as string);

				if (this.isSameEditSession(runId, rowKey)) {
					this.exitEdit();
				}

				if (rowKey === this.photoRowKey) {
					this.advancePhotoAfterDecision();
				}
			})
			.catch((error2) => {
				const mmError = readMmError(error2, 'results/correct');
				const message = mmError.message ? String(mmError.message) : '';

				if (this.isSameEditSession(runId, rowKey)) {
					this.editError = '';
				}

				this.showError(message !== '' ? message : (this.$t(KEY + 'correctError') as string));
			})
			.finally(() => {
				this.savingRowKey = null;
			});
	}

	private isSameEditSession(runId: number, rowKey: string): boolean {
		return this.editRunId === runId && this.editingRowKey === rowKey;
	}

	private replaceRowResult(rowKey: string, updated: MmMonitoringResult): void {
		for (let i = 0; i < this.rows.length; i += 1) {
			if (this.rows[i].key === rowKey) {
				const next = this.rows.slice();

				next[i] = {
					key: this.rows[i].key,
					result: updated,
					classification: this.rows[i].classification,
					planItem: this.rows[i].planItem,
					isMissing: false,
					isDuplicate: this.rows[i].isDuplicate,
					extraCaptures: this.rows[i].extraCaptures,
				};

				this.rows = next;

				if (this.photoAnchorRow !== null && this.photoAnchorRow.key === rowKey) {
					this.photoAnchorRow = next[i];
				}

				this.syncPhotoQueueRow(rowKey, next[i]);

				return;
			}
		}
	}

	/** Часть колонок в DTO результата отсутствует: читаем их как необязательные поля через одну функцию */
	private readRawField(source: any, field: string): string {
		if (!source || source[field] === null || source[field] === undefined) {
			return '';
		}

		return String(source[field]).trim();
	}

	readField(row: MmResultRow, field: string): string {
		return orDash(this.readRawField(row.result, field));
	}

	readVolume(row: MmResultRow): string {
		const value = this.readNumberField(row.result, 'productVolume');

		if (value === null) {
			return orDash(this.readRawField(row.result, 'recognizedVgh'));
		}

		const unit = this.readRawField(row.result, 'measurementUnit');

		return unit !== '' ? String(value) + ' ' + unit : String(value);
	}

	/** Читаем через any: ключа в ответе может не быть вовсе, а сравнение с null такой случай пропустит */
	private readNumberField(source: any, field: string): number | null {
		if (!source || source[field] === null || source[field] === undefined) {
			return null;
		}

		const value = Number(source[field]);

		return isNaN(value) ? null : value;
	}

	private readFlagField(source: any, field: string): boolean | null {
		if (!source || source[field] === null || source[field] === undefined) {
			return null;
		}

		return source[field] === true;
	}

	readProductName(row: MmResultRow): string {
		if (row.result === null) {
			return MM_EMPTY_DASH;
		}

		const recognizedName = this.readRawField(row.result, 'recognizedName');

		return recognizedName !== '' ? recognizedName : MM_EMPTY_DASH;
	}

	readProductNameHint(row: MmResultRow): string {
		return this.readProductName(row);
	}

	readOurProduct(row: MmResultRow): string {
		const planned = this.readPlannedSkuName(row);

		if (planned !== '') {
			return planned;
		}

		const direct = this.readRawField(row.result, 'ourProductName');

		return orDash(direct !== '' ? direct : this.readRawField(row.result, 'skuName'));
	}

	private readPlannedSkuName(row: MmResultRow): string {
		const item = this.readLinkedPlanItem(row);

		if (!item || item.skuName === null || item.skuName === undefined) {
			return '';
		}

		return String(item.skuName).trim();
	}

	private readLinkedPlanItem(row: MmResultRow): MmTaskItem | null {
		if (row.planItem) {
			return row.planItem;
		}

		const result = row.result;

		if (result === null || result.taskProductId === null || result.taskProductId === undefined) {
			return null;
		}

		const item = this.planItems[String(result.taskProductId)];

		return item ? item : null;
	}

	readRowClassificationLabel(row: MmResultRow): string {
		if (row.classification === null) {
			return MM_EMPTY_DASH;
		}

		return this.readClassificationTitle(row.classification);
	}

	readRowClassificationPath(row: MmResultRow): string {
		const classification = row.classification;

		if (classification === null) {
			return '';
		}

		const path = formatLevelPath(
			classification.groupName,
			classification.categoryName,
			classification.subcategoryName,
		);

		return path === this.readClassificationTitle(classification) ? '' : path;
	}

	/** Ноль — настоящая цена и рисуется как 0.00, а не прочерком */
	readPrice(row: MmResultRow): string {
		const result = row.result;

		if (result === null) {
			return MM_EMPTY_DASH;
		}

		const corrected = this.readNumberField(result, 'correctedPrice');

		return corrected !== null ? formatMoney(corrected) : formatMoney(this.readNumberField(result, 'price'));
	}

	readOriginalPrice(row: MmResultRow): string {
		const result = row.result;

		if (result === null || this.readNumberField(result, 'correctedPrice') === null) {
			return '';
		}

		return formatMoney(this.readNumberField(result, 'price'));
	}

	readPromo(row: MmResultRow): string {
		return row.result === null ? MM_EMPTY_DASH : formatMoney(row.result.promoPrice);
	}

	readOutcome(row: MmResultRow): string {
		return resolveOutcome(row.result, this.taskType);
	}

	readSkipReason(row: MmResultRow): string {
		const result = row.result;

		return result === null ? '' : this.skipReasonLabel(result.skipReason);
	}

	private skipReasonLabel(raw: string | null): string {
		const code = normalizeSkipReason(raw);

		if (code === '') {
			return '';
		}

		const key = skipReasonKey(code);
		const translated = this.$t(key) as string;

		return translated === key ? code : translated;
	}

	readCapturedAt(row: MmResultRow): string {
		return row.result === null ? MM_EMPTY_DASH : formatDateTime(row.result.capturedAt);
	}

	readReceivedAt(row: MmResultRow): string {
		return row.result === null ? MM_EMPTY_DASH : formatDateTime(row.result.receivedAt);
	}

	isLateData(row: MmResultRow): boolean {
		const result = row.result;

		if (result === null || !result.capturedAt || !result.receivedAt) {
			return false;
		}

		const captured = new Date(result.capturedAt).getTime();
		const received = new Date(result.receivedAt).getTime();

		if (isNaN(captured) || isNaN(received)) {
			return false;
		}

		return received - captured > LATE_DATA_HOURS * 3600 * 1000;
	}

	get emptyDash(): string {
		return MM_EMPTY_DASH;
	}

	readTaskRef(row: MmResultRow): string {
		if (row.result === null) {
			return MM_EMPTY_DASH;
		}

		const fromRow = this.readNonEmptyText(row.result.competitorStoreName);

		if (fromRow !== '') {
			return fromRow;
		}

		const fromTask = this.readTaskStoreLabel();

		if (fromTask !== '') {
			return fromTask;
		}

		const display = this.readNonEmptyText(row.result.taskDisplayNumber);

		if (display !== '') {
			return display;
		}

		return MM_EMPTY_DASH;
	}

	private readTaskStoreLabel(): string {
		const task = this.task;

		if (task === null || task === undefined) {
			return '';
		}

		const store = task.competitorStore;

		if (store === null || store === undefined) {
			return '';
		}

		const name = this.readNonEmptyText(store.name);

		if (name !== '') {
			return name;
		}

		return this.readNonEmptyText(store.competitorNetworkName);
	}

	private readNonEmptyText(value: string | null | undefined): string {
		if (value === null || value === undefined) {
			return '';
		}

		const text = String(value).trim();

		return text !== '' ? text : '';
	}

	readTaskCreatedAt(row: MmResultRow): string {
		if (row.result === null) {
			return '';
		}

		const created = row.result.taskCreatedAt;

		return created !== null && created !== undefined && created !== ''
			? formatDateTime(created)
			: '';
	}

	readPriceSource(row: MmResultRow): string {
		return this.readRawField(row.result, 'priceSource');
	}

	readPriceSourceLabel(row: MmResultRow): string {
		const code = this.readPriceSource(row);

		if (code === '') {
			return MM_EMPTY_DASH;
		}

		const spec = getBadgeSpec('priceSource', code);

		if (spec) {
			return this.$t(spec.labelKey) as string;
		}

		return code;
	}

	readOutcomeLabel(row: MmResultRow): string {
		const code = this.readOutcome(row);
		const spec = getBadgeSpec('outcome', code);

		if (spec) {
			return this.$t(spec.labelKey) as string;
		}

		return code;
	}

	readPriceCheckerBrief(row: MmResultRow): string {
		const result = row.result;

		if (result === null || !Array.isArray(result.priceCheckerRecords)
			|| result.priceCheckerRecords.length === 0) {
			return MM_EMPTY_DASH;
		}

		const records = result.priceCheckerRecords;
		const first = records[0];
		const firstPrice = formatMoney(first ? first.price : null);

		if (records.length === 1) {
			return firstPrice;
		}

		return this.$t('priceMonitoring.mobileMonitoring.photos.priceCheckerBrief', {
			count: records.length,
			price: firstPrice,
		}) as string;
	}

	readWasProductRecognized(row: MmResultRow): string {
		const flag = this.readFlagField(row.result, 'wasProductRecognized');

		if (flag === null) {
			return MM_EMPTY_DASH;
		}

		return flag
			? (this.$t('shared.actions.yes') as string)
			: (this.$t('shared.actions.no') as string);
	}

	readTaskType(row: MmResultRow): string {
		if (row.result === null) {
			return '';
		}

		const type = row.result.taskType;

		return type !== null && type !== undefined ? String(type) : '';
	}

	readCompetitorStore(row: MmResultRow): string {
		if (row.result === null) {
			return MM_EMPTY_DASH;
		}

		const code = row.result.competitorCode;
		const name = row.result.competitorStoreName;
		const hasCode = code !== null && code !== undefined && code !== '';
		const hasName = name !== null && name !== undefined && name !== '';

		if (hasCode && hasName) {
			return String(code) + ' · ' + String(name);
		}

		if (hasCode) {
			return String(code);
		}

		return hasName ? String(name) : MM_EMPTY_DASH;
	}

	handleOpenTask(row: MmResultRow): void {
		if (row.result === null) {
			return;
		}

		const taskId = row.result.taskId;

		if (taskId !== null && taskId !== undefined && taskId !== '') {
			this.$emit('open-task', String(taskId));
		}
	}

	readAuditor(row: MmResultRow): string {
		if (row.result === null) {
			return MM_EMPTY_DASH;
		}

		const fullName = row.result.auditorFullName;

		if (fullName !== null && fullName !== undefined && String(fullName).trim() !== '') {
			return String(fullName);
		}

		if (row.result.auditorLogin) {
			return orDash(row.result.auditorLogin);
		}

		const task = this.task;

		if (task !== null && task !== undefined) {
			if (task.auditorFullName) {
				return String(task.auditorFullName);
			}

			if (task.auditorLogin) {
				return String(task.auditorLogin);
			}
		}

		return MM_EMPTY_DASH;
	}

	readComment(row: MmResultRow): string {
		return this.readField(row, 'comment');
	}

	readReviewStatus(row: MmResultRow): string {
		if (row.result === null) {
			return MmReviewStatus.PENDING;
		}

		return row.result.reviewStatus ? String(row.result.reviewStatus) : MmReviewStatus.PENDING;
	}

	readShootingLocation(row: MmResultRow): string {
		if (row.result === null) {
			return '';
		}

		let name = this.readNonEmptyText(row.result.competitorStoreName);
		const ownerTask = this.resolveOwnerTask(row);

		if (name === '' && ownerTask !== null && ownerTask.competitorStore !== null) {
			const store = ownerTask.competitorStore;
			name = this.readNonEmptyText(store.name);

			if (name === '') {
				name = this.readNonEmptyText(store.competitorNetworkName);
			}
		}

		let address = '';

		if (ownerTask !== null && ownerTask.competitorStore !== null) {
			address = this.readNonEmptyText(ownerTask.competitorStore.address);
		}

		if (name !== '' && address !== '') {
			return name + ' · ' + address;
		}

		if (name !== '') {
			return name;
		}

		return address;
	}

	private resolveOwnerTask(row: MmResultRow): MmTask | null {
		if (row.result === null) {
			return null;
		}

		const taskId = row.result.taskId;
		const scopeTasks = this.ctx.scopeTasks;

		if (scopeTasks !== null && scopeTasks !== undefined && taskId !== null && taskId !== undefined && taskId !== '') {
			const id = String(taskId);

			for (let i = 0; i < scopeTasks.length; i += 1) {
				if (String(scopeTasks[i].id) === id) {
					return scopeTasks[i];
				}
			}
		}

		return this.task !== null && this.task !== undefined ? this.task : null;
	}

	/** Значение уже в процентах, а не доля: на 100 не умножать */
	readConfidence(row: MmResultRow): string {
		const result = row.result;

		const value = this.readNumberField(result, 'confidenceLevel');

		if (value === null) {
			return MM_EMPTY_DASH;
		}

		return String(Math.round(value)) + '%';
	}

	/** Шкала источника двойная: доли домножаем на 100, значения больше единицы уже в процентах */
	private readConfidenceField(source: any, field: string): string {
		const value = this.readNumberField(source, field);

		if (value === null) {
			return MM_EMPTY_DASH;
		}

		const percent = value > 0 && value <= 1 ? value * 100 : value;

		return String(Math.round(percent)) + '%';
	}

	/** Погрешность и высота — в метрах; имена полей одинаковы у позиции и у записи прайс-чекера */
	private readGeo(source: any): string {
		const latitude = this.readNumberField(source, 'geoLatitude');
		const longitude = this.readNumberField(source, 'geoLongitude');

		if (latitude === null || longitude === null) {
			return MM_EMPTY_DASH;
		}

		const parts: string[] = [latitude.toFixed(5) + ', ' + longitude.toFixed(5)];
		const accuracy = this.readNumberField(source, 'geoAccuracy');

		if (accuracy !== null) {
			parts.push(this.$t(PHOTOS_KEY + 'gpsAccuracy', {
				value: String(Math.round(accuracy)),
			}) as string);
		}

		const altitude = this.readNumberField(source, 'geoAltitude');

		if (altitude !== null) {
			parts.push(this.$t(PHOTOS_KEY + 'gpsAltitude', {
				value: String(Math.round(altitude)),
			}) as string);
		}

		return parts.join(' ');
	}

	/** Яндекс принимает долготу первой; зум 17 показывает здание, а не область */
	private readGeoMapsUrl(source: any): string {
		const latitude = this.readNumberField(source, 'geoLatitude');
		const longitude = this.readNumberField(source, 'geoLongitude');

		if (latitude === null || longitude === null) {
			return '';
		}

		const point = String(longitude) + ',' + String(latitude);

		return 'https://yandex.ru/maps/?ll=' + point + '&z=17&pt=' + point + '&l=map';
	}

	readPhotos(row: MmResultRow): MmPhoto[] {
		const result = row.result;

		if (result === null || !Array.isArray(result.photos)) {
			return [];
		}

		return result.photos;
	}

	readFoundKind(row: MmResultRow): string {
		const isAnalog = this.readFlagField(row.result, 'isAnalog');

		if (isAnalog === null) {
			return MM_EMPTY_DASH;
		}

		return isAnalog
			? '≈ ' + (this.$t(KEY + 'foundKindAnalog') as string)
			: '✓ ' + (this.$t(KEY + 'foundKindSame') as string);
	}

	readFoundKindClass(row: MmResultRow): string {
		const isAnalog = this.readFlagField(row.result, 'isAnalog');

		if (isAnalog === null) {
			return 'sm-mobilemon__res-muted';
		}

		return isAnalog ? 'sm-mobilemon__res-analog' : 'sm-mobilemon__res-same';
	}

	readExpectedPrice(row: MmResultRow): string {
		const value = this.readExpectedPriceValue(row);

		return value === null ? MM_EMPTY_DASH : formatMoney(value);
	}

	/** Эталон берётся из позиции плана по ссылке taskProductId, чтение из результата — запасной путь */
	private readExpectedPriceValue(row: MmResultRow): number | null {
		const fromPlan = this.readPlanExpectedPrice(row);

		if (fromPlan !== null) {
			return fromPlan;
		}

		const direct = this.readRawField(row.result, 'expectedPrice');
		const fallback = this.readRawField(row.result, 'expectedRegularPrice');
		const raw = direct !== '' ? direct : fallback;

		if (raw === '') {
			return null;
		}

		const value = Number(raw);

		return isNaN(value) ? null : value;
	}

	private readPlanExpectedPrice(row: MmResultRow): number | null {
		const result = row.result;

		if (result === null) {
			return row.planItem ? this.readNumberField(row.planItem, 'expectedRegularPrice') : null;
		}

		if (result.taskProductId === null || result.taskProductId === undefined) {
			return null;
		}

		const item = this.planItems[String(result.taskProductId)];

		if (!item) {
			return null;
		}

		return this.readNumberField(item, 'expectedRegularPrice');
	}

	readDeviation(row: MmResultRow): string {
		const value = this.readDeviationValue(row);

		return value === null ? '' : value.toFixed(2) + '%';
	}

	private readDeviationValue(row: MmResultRow): number | null {
		const expected = this.readExpectedPriceValue(row);
		const result = row.result;

		if (expected === null || expected === 0 || result === null) {
			return null;
		}

		const corrected = this.readNumberField(result, 'correctedPrice');
		const actual = corrected !== null ? corrected : this.readNumberField(result, 'price');

		if (actual === null) {
			return null;
		}

		return ((actual - expected) / expected) * 100;
	}

	readDeviationClass(row: MmResultRow): string {
		const value = this.readDeviationValue(row);
		const outcome = resolveOutcome(row.result, this.taskType);

		if (value === null || outcome === MmOutcome.ANALOG_COMPARE_FAILED || outcome === MmOutcome.UNSPECIFIED) {
			return '';
		}

		return Math.abs(value) > MM_KVI_DEVIATION_LIMIT_PERCENT ? 'deviation-unacceptable' : 'deviation-acceptable';
	}

	buildResultRowClass(record: MmResultRow): string {
		const classes: string[] = [];

		if (record && record.isMissing) {
			classes.push('sm-mobilemon__res-row--missing');
		}

		if (record && record.key === this.highlightedKey) {
			classes.push('sm-mobilemon__res-row--highlight');
		}

		return classes.join(' ');
	}

	private get taskStatus(): string {
		return this.task !== null && this.task.status ? String(this.task.status) : '';
	}


	/** В сводном режиме статус задания-представителя брать нельзя: строки собраны со всей пачки */
	private isAwaitingAuditorClose(): boolean {
		if (this.ctx.scope === 'batch') {
			const tasks = this.ctx.scopeTasks;

			if (tasks !== null && tasks !== undefined) {
				for (let i = 0; i < tasks.length; i += 1) {
					if (isTaskAwaitingClose(tasks[i])) {
						return true;
					}
				}

				return false;
			}
		}

		return this.taskStatus === MmTaskStatus.ASSIGNED && this.resultsTotal > 0;
	}

	get isToolbarVisible(): boolean {
		return this.blockingState === '';
	}

	get hasPendingQuickFilterChanges(): boolean {
		return this.draftOnlyLatest !== this.onlyLatest
			|| this.draftOnlyUnspecifiedOutcome !== this.onlyUnspecifiedOutcome
			|| this.draftOnlyAnalogs !== this.onlyAnalogs;
	}

	/** draft и cancelled в рабочем наборе статусов отсутствуют, но сервер их прислать может */
	get blockingState(): string {
		if (this.isSummaryLoading && !this.hasLoadedSummary) {
			return 'loading';
		}

		if (this.loadError !== null) {
			return 'error';
		}

		if (this.task === null) {
			return 'loading';
		}

		if (this.taskStatus === 'draft') {
			return 'empty';
		}

		if (this.isCompletedWithoutResults()) {
			return 'error';
		}

		if (
			this.taskStatus === MmTaskStatus.ASSIGNED
			&& this.resultsTotal === 0
			&& this.canTreatEmptyAsNoWork()
		) {
			return 'empty';
		}

		return '';
	}

	private canTreatEmptyAsNoWork(): boolean {
		if (this.ctx.scope === 'batch') {
			return false;
		}

		return !this.isSelectionNarrowedByFilters();
	}

	private isSelectionNarrowedByFilters(): boolean {
		if (this.onlyUnspecifiedOutcome === true || this.onlyAnalogs === true || this.onlyLatest === true) {
			return true;
		}

		return this.hasNarrowingScopeFilters();
	}

	/** Фильтры сужают выдачу, поэтому «не выполнено» по ней не достраиваем; onlyLatest не сужает */
	private hasNarrowingScopeFilters(): boolean {
		const scopeFilters = this.ctx.scopeFilters;

		if (scopeFilters === null || scopeFilters === undefined) {
			return false;
		}

		const scope: { [key: string]: any } = scopeFilters;
		const keys = Object.keys(scope);

		for (let i = 0; i < keys.length; i += 1) {
			const key = keys[i];
			const value = scope[key];

			if (key === 'taskIds') {
				if (this.isTaskIdsFilterNarrowing(value)) {
					return true;
				}

				continue;
			}

			if (this.isFilterValueNarrowing(value)) {
				return true;
			}
		}

		return false;
	}

	private isTaskIdsFilterNarrowing(taskIds: any): boolean {
		if (!Array.isArray(taskIds) || taskIds.length === 0) {
			return false;
		}

		const plan = this.ctx.planTaskIds;

		if (plan === null || plan === undefined || plan.length === 0) {
			return false;
		}

		return taskIds.length < plan.length;
	}

	private isFilterValueNarrowing(value: any): boolean {
		if (value === null || value === undefined || value === false || value === '') {
			return false;
		}

		if (Array.isArray(value)) {
			return value.length > 0;
		}

		return true;
	}

	private isCompletedWithoutResults(): boolean {
		const isFinished = this.taskStatus === MmTaskStatus.COMPLETED || this.taskStatus === MmTaskStatus.ACCEPTED;

		return isFinished
			&& this.aggregates.length >= 0
			&& this.resultsTotal === 0
			&& !this.isSummaryLoading
			&& this.canTreatEmptyAsNoWork();
	}

	get blockingTitle(): string {
		if (this.blockingState === 'loading' || this.blockingState === '') {
			return '';
		}

		if (this.loadError !== null) {
			return this.$t(KEY + 'loadError') as string;
		}

		if (this.taskStatus === 'draft') {
			return this.$t(KEY + 'stateDraft') as string;
		}

		if (this.isCompletedWithoutResults()) {
			return this.$t(KEY + 'stateNoResults') as string;
		}

		return this.$t(KEY + 'stateNotStarted') as string;
	}

	get blockingText(): string {
		if (this.blockingState === 'loading' || this.blockingState === '') {
			return '';
		}

		if (this.loadError !== null) {
			return '';
		}

		if (this.taskStatus === 'draft') {
			return this.$t(KEY + 'stateDraftHint') as string;
		}

		if (this.isCompletedWithoutResults()) {
			return this.$t(KEY + 'stateNoResultsHint') as string;
		}

		return this.$t(KEY + 'stateNotStartedHint') as string;
	}

	get loadErrorText(): string {
		if (this.loadError === null) {
			return '';
		}

		const message = this.loadError.message ? String(this.loadError.message).trim() : '';

		return message !== '' ? message : (this.$t(KEY + 'loadErrorHint') as string);
	}

	get loadErrorDiagnostics(): string {
		return this.loadError === null ? '' : formatDiagnostics(this.loadError.diagnostics);
	}

	get isLoadErrorRetryable(): boolean {
		if (this.loadError !== null) {
			return this.loadError.retryable;
		}

		return this.isCompletedWithoutResults();
	}

	/** Ключ подписи кнопки не менять: тексты плашек называют её по имени */
	get banners(): MmResultBanner[] {
		const banners: MmResultBanner[] = [];

		if (this.task === null) {
			return banners;
		}

		// В сводном режиме task — представитель пачки, его статус не равен статусу строк
		if (this.isAwaitingAuditorClose()) {
			banners.push({
				key: 'inProgress',
				tone: 'info',
				icon: 'clock-circle',
				title: this.$t(KEY + 'stateInProgress') as string,
				text: this.$t(KEY + 'stateInProgressHint') as string,
				quote: '',
				action: this.$t('shared.actions.update') as string,
			});
		}

		if (this.isDeliveryIncomplete()) {
			banners.push({
				key: 'partial',
				tone: 'warning',
				icon: 'cloud-download',
				title: this.$t(KEY + 'statePartial', { count: this.resultsTotal }) as string,
				text: this.ctx.scope === 'batch'
					? (this.$t(KEY + 'statePartialHintBatch') as string)
					: (this.$t(KEY + 'statePartialHint') as string),
				quote: '',
				action: this.$t('shared.actions.update') as string,
			});
		}

		const unspecified = this.countUnspecified();

		if (unspecified > 0 && !this.onlyUnspecifiedOutcome) {
			banners.push({
				key: 'gaps',
				tone: 'warning',
				icon: 'exclamation-circle',
				title: this.$t(KEY + 'stateGaps', { count: unspecified }) as string,
				text: this.$t(KEY + 'stateGapsHint') as string,
				quote: '',
				action: this.$t(KEY + 'filterUnspecifiedOnly') as string,
			});
		}

		if (this.taskStatus === MmTaskStatus.REJECTED) {
			banners.push({
				key: 'rejected',
				tone: 'danger',
				icon: 'close-circle',
				title: this.$t(KEY + 'stateRejected') as string,
				text: this.readRejectComment() !== '' ? (this.$t(KEY + 'stateRejectedComment') as string) : '',
				quote: this.readRejectComment(),
				action: '',
			});
		}

		if (this.taskStatus === 'cancelled') {
			banners.push({
				key: 'cancelled',
				tone: 'neutral',
				icon: 'stop',
				title: this.$t(KEY + 'stateCancelled') as string,
				text: this.$t(KEY + 'stateCancelledHint') as string,
				quote: this.readCancelReason(),
				action: '',
			});
		}

		return banners;
	}

	/** Считаем по агрегатам и общему счётчику, а не по загруженным строкам: страница знает лишь свои */
	private countUnspecified(): number {
		let total = 0;
		let known = false;

		for (let i = 0; i < this.aggregates.length; i += 1) {
			const value = this.readNumberField(this.aggregates[i], 'positionsUnspecified');

			if (value !== null) {
				known = true;
				total += value;
			}
		}

		if (known) {
			return total;
		}

		return this.resultsUnspecifiedTotal !== null ? this.resultsUnspecifiedTotal : 0;
	}

	private readRejectComment(): string {
		const source: any = this.task;

		if (!source) {
			return '';
		}

		const value = source.auditorComment !== undefined && source.auditorComment !== null
			? source.auditorComment
			: source.rejectComment;

		return value === undefined || value === null ? '' : String(value).trim();
	}

	private readCancelReason(): string {
		const source: any = this.task;

		if (!source || source.cancelReason === undefined || source.cancelReason === null) {
			return '';
		}

		return String(source.cancelReason).trim();
	}

	isBannerReloadAction(key: string): boolean {
		return key !== 'gaps';
	}

	handleBannerAction(key: string): void {
		if (!this.isBannerReloadAction(key)) {
			this.confirmSelectionReset(() => {
				this.draftOnlyUnspecifiedOutcome = true;
				this.onlyUnspecifiedOutcome = true;
				this.persistViewState();
				this.loadSummary();
			});

			return;
		}

		this.reload();
	}

	get isPhotoVisible(): boolean {
		return this.photoRowKey !== ''
			&& this.photoAnchorRow !== null
			&& this.photoAnchorRow.key === this.photoRowKey;
	}

	/** Пока окно открыто, листаем зафиксированную очередь: фильтр мог убрать строку из таблицы */
	get photoRows(): MmResultRow[] {
		if (this.photoRowKey !== '' && this.photoQueue.length > 0) {
			return this.photoQueue;
		}

		return this.buildPhotoQueueFromRows();
	}

	get photoPosition(): number {
		if (this.photoRowKey === '') {
			return -1;
		}

		const rows = this.photoRows;

		for (let i = 0; i < rows.length; i += 1) {
			if (rows[i].key === this.photoRowKey) {
				return i;
			}
		}

		return -1;
	}

	get photoRow(): MmResultRow | null {
		if (this.photoRowKey === '' || this.photoAnchorRow === null) {
			return null;
		}

		if (this.photoAnchorRow.key !== this.photoRowKey) {
			return null;
		}

		return this.photoAnchorRow;
	}

	get photoList(): MmPhoto[] {
		const row = this.photoRow;

		return row === null ? [] : this.readPhotos(row);
	}

	get photoTitle(): string {
		const row = this.photoRow;

		if (row === null) {
			return '';
		}

		const parts: string[] = [];
		const price = this.photoSubmittedPrice;

		if (price !== MM_EMPTY_DASH && String(price).trim() !== '') {
			parts.push(String(price).trim());
		}

		if (this.hasFoundKindColumn) {
			const kind = this.readFoundKind(row);

			if (kind !== MM_EMPTY_DASH && String(kind).trim() !== '') {
				parts.push(String(kind).trim());
			}
		}

		const name = this.readPhotoTitleName(row);

		if (name !== '' && name !== MM_EMPTY_DASH) {
			parts.push(name);
		}

		return parts.join(' · ');
	}

	private readPhotoTitleName(row: MmResultRow): string {
		if (this.usesProductPlan) {
			const ours = this.readPlannedSkuName(row);

			if (ours !== '') {
				return ours;
			}

			const labeled = this.readOurProduct(row);

			if (labeled !== MM_EMPTY_DASH) {
				return labeled;
			}
		}

		const product = this.readProductName(row);

		return product === MM_EMPTY_DASH ? '' : product;
	}

	get photoAuditor(): string {
		const row = this.photoRow;

		return row === null ? '' : this.readAuditor(row);
	}

	get photoCapturedAtFallback(): string {
		const row = this.photoRow;

		if (row === null || row.result === null || !row.result.capturedAt) {
			return '';
		}

		return String(row.result.capturedAt);
	}

	get photoShootingLocation(): string {
		const row = this.photoRow;

		return row === null ? '' : this.readShootingLocation(row);
	}

	get photoSubmittedPrice(): string {
		const row = this.photoRow;

		if (row === null || row.result === null) {
			return MM_EMPTY_DASH;
		}

		return formatMoney(this.readNumberField(row.result, 'price'));
	}

	get photoCorrectedPrice(): string {
		const row = this.photoRow;

		if (row === null || row.result === null) {
			return '';
		}

		const corrected = this.readNumberField(row.result, 'correctedPrice');

		return corrected !== null ? formatMoney(corrected) : '';
	}

	get photoAuditorPromo(): string {
		const row = this.photoRow;

		return row === null ? MM_EMPTY_DASH : this.readPromo(row);
	}

	get photoAuditorProductName(): string {
		const row = this.photoRow;

		return row === null ? MM_EMPTY_DASH : this.readProductName(row);
	}

	get photoAuditorBarCode(): string {
		const row = this.photoRow;

		return row === null ? MM_EMPTY_DASH : this.readField(row, 'barCode');
	}

	get photoAuditorOutcome(): string {
		const row = this.photoRow;

		return row === null ? MM_EMPTY_DASH : this.readOutcomeLabel(row);
	}

	get photoAuditorSkipReason(): string {
		const row = this.photoRow;

		if (row === null) {
			return MM_EMPTY_DASH;
		}

		const reason = this.readSkipReason(row);

		return reason !== '' ? reason : MM_EMPTY_DASH;
	}

	get photoAuditorFoundKind(): string {
		const row = this.photoRow;

		return row === null ? MM_EMPTY_DASH : this.readFoundKind(row);
	}

	get photoAuditorTpcSubcategory(): string {
		const row = this.photoRow;

		return row === null ? MM_EMPTY_DASH : this.readRowClassificationLabel(row);
	}

	get photoAuditorConfidence(): string {
		const row = this.photoRow;

		return row === null ? MM_EMPTY_DASH : this.readConfidence(row);
	}

	get photoAuditorPriceSource(): string {
		const row = this.photoRow;

		return row === null ? MM_EMPTY_DASH : this.readPriceSourceLabel(row);
	}

	get photoAuditorPriceChecker(): string {
		const row = this.photoRow;

		return row === null ? MM_EMPTY_DASH : this.readPriceCheckerBrief(row);
	}

	get photoAuditorProductRecognized(): string {
		const row = this.photoRow;

		return row === null ? MM_EMPTY_DASH : this.readWasProductRecognized(row);
	}

	get photoAuditorCardPrice(): string {
		const row = this.photoRow;

		return row === null ? MM_EMPTY_DASH : formatMoney(this.readNumberField(row.result, 'cardPrice'));
	}

	get photoAuditorWholesalePrice(): string {
		const row = this.photoRow;

		return row === null
			? MM_EMPTY_DASH
			: formatMoney(this.readNumberField(row.result, 'wholesalePrice'));
	}

	get photoAuditorWholesaleVolume(): string {
		const row = this.photoRow;

		return row === null ? MM_EMPTY_DASH : this.readField(row, 'wholesaleVolume');
	}

	get photoAuditorCompetitorSku(): string {
		const row = this.photoRow;

		return row === null ? MM_EMPTY_DASH : this.readField(row, 'competitorSku');
	}

	get photoAuditorPromoType(): string {
		const row = this.photoRow;

		return row === null ? MM_EMPTY_DASH : this.readField(row, 'promoType');
	}

	get photoAuditorCurrency(): string {
		const row = this.photoRow;

		return row === null ? MM_EMPTY_DASH : this.readField(row, 'currency');
	}

	get photoAuditorVgh(): string {
		const row = this.photoRow;

		return row === null ? MM_EMPTY_DASH : this.readField(row, 'recognizedVgh');
	}

	get photoAuditorConfidenceName(): string {
		const row = this.photoRow;

		return row === null
			? MM_EMPTY_DASH
			: this.readConfidenceField(row.result, 'confidenceName');
	}

	get photoAuditorConfidencePromo(): string {
		const row = this.photoRow;

		return row === null
			? MM_EMPTY_DASH
			: this.readConfidenceField(row.result, 'confidencePromo');
	}

	get photoAuditorConfidenceBarcode(): string {
		const row = this.photoRow;

		return row === null
			? MM_EMPTY_DASH
			: this.readConfidenceField(row.result, 'confidenceBarcode');
	}

	get photoAuditorConfidenceVgh(): string {
		const row = this.photoRow;

		return row === null ? MM_EMPTY_DASH : this.readConfidenceField(row.result, 'confidenceVgh');
	}

	get photoAuditorComment(): string {
		const row = this.photoRow;

		return row === null ? MM_EMPTY_DASH : this.readField(row, 'auditorComment');
	}

	get photoGpsCoordinates(): string {
		const row = this.photoRow;

		return row === null ? MM_EMPTY_DASH : this.readGeo(row.result);
	}

	get photoGpsMapsUrl(): string {
		const row = this.photoRow;

		if (row === null || row.result === null) {
			return '';
		}

		return this.readGeoMapsUrl(row.result);
	}

	get photoPositionCounter(): string {
		const at = this.photoPosition;
		const total = this.photoRows.length;

		if (at === -1 || total < 2) {
			return '';
		}

		return this.$t('priceMonitoring.mobileMonitoring.photos.counter', {
			current: at + 1,
			total: total,
		}) as string;
	}

	get hasPrevPhotoPosition(): boolean {
		return this.photoPosition > 0;
	}

	get hasNextPhotoPosition(): boolean {
		const at = this.photoPosition;

		return at !== -1 && at < this.photoRows.length - 1;
	}

	get canReviewPhotoRow(): boolean {
		const row = this.photoRow;

		return row !== null && this.canReviewRow(row);
	}

	get canEditPhotoRow(): boolean {
		const row = this.photoRow;

		return row !== null && this.canEditPrice(row);
	}

	get photoReviewBlockedReason(): string {
		const row = this.photoRow;

		return row === null ? (this.$t(KEY + 'actionNoResult') as string) : this.reviewBlockedReason(row);
	}

	get photoEditBlockedReason(): string {
		const row = this.photoRow;

		return row === null ? (this.$t(KEY + 'actionNoResult') as string) : this.editBlockedReason(row);
	}

	openPhotos(row: MmResultRow, index: number): void {
		if (this.readPhotos(row).length === 0) {
			return;
		}

		this.photoQueue = this.buildPhotoQueueFromRows();
		this.photoAnchorRow = row;
		this.photoRowKey = row.key;
		this.photoStartIndex = index;
	}

	/** Панель правки сбрасываем до смены позиции, иначе недосохранённая цена уйдёт соседнему товару */
	handlePhotoPositionStep(step: number): void {
		const at = this.photoPosition;

		if (at === -1) {
			return;
		}

		const rows = this.photoRows;
		const next = at + step;

		if (next < 0 || next >= rows.length) {
			return;
		}

		this.closePhotoPanel();

		this.photoAnchorRow = rows[next];
		this.photoRowKey = rows[next].key;
		this.photoStartIndex = 0;
	}

	get isPhotoEditOpen(): boolean {
		const row = this.photoRow;

		return row !== null && this.editingRowKey === row.key;
	}

	/** Вторая половина проверки не избыточна: позицию можно пролистнуть при открытой форме */
	get isPhotoRejectOpen(): boolean {
		const row = this.photoRow;

		return row !== null
			&& this.rejectInPhoto
			&& this.rejectRow !== null
			&& this.rejectRow.key === row.key;
	}

	get isPhotoPanelOpen(): boolean {
		return this.isPhotoEditOpen || this.isPhotoRejectOpen;
	}

	get isPhotoSaving(): boolean {
		const row = this.photoRow;

		return row !== null && this.savingRowKey === row.key;
	}

	get isPhotoPanelBusy(): boolean {
		return this.isPhotoSaving || this.isBulkBusy;
	}

	get photoOriginalPriceText(): string {
		const row = this.photoRow;

		return row === null ? MM_EMPTY_DASH : this.readPrice(row);
	}

	get photoSaveBlockedReason(): string {
		if (this.isPhotoSaving) {
			return this.$t(KEY + 'actionBusy') as string;
		}

		if (this.editError !== '') {
			return this.editError;
		}

		return this.$t(KEY + 'correctInvalid') as string;
	}

	handlePhotoEditSave(): void {
		const row = this.photoRow;

		if (row === null) {
			return;
		}

		this.handleEditSave(row);
	}

	handlePhotoEditCancel(): void {
		this.handleEditCancel();
	}

	handlePhotoPanelCancel(): void {
		if (this.isPhotoPanelBusy) {
			return;
		}

		this.closePhotoPanel();
	}

	private closePhotoPanel(): void {
		if (this.isPhotoEditOpen) {
			this.exitEdit();
		}

		if (this.isPhotoRejectOpen) {
			this.closeRowReject();
		}
	}

	handlePhotoAction(action: string): void {
		const row = this.photoRow;

		if (row === null) {
			return;
		}

		if (action === 'correct') {
			this.startEdit(row, 'photoPriceInput');

			return;
		}

		if (action === 'reject') {
			this.openRowReject(row, true);

			return;
		}

		this.handleRowAction(row, action);
	}

	closePhotos(): void {
		this.closePhotoPanel();

		this.photoRowKey = '';
		this.photoAnchorRow = null;
		this.photoStartIndex = 0;
		this.photoQueue = [];
	}

	@Watch('isPhotoVisible')
	onPhotoVisibleChanged(next: boolean, prev: boolean): void {
		if (prev === true && next === false && !this.suppressPhotoFlush) {
			this.flushPhotoBackground();
		}
	}

	private flushPhotoBackground(): void {
		this.needsReload = false;
		this.reload();
		this.notifyReviewComplete();
	}

	private buildPhotoQueueFromRows(): MmResultRow[] {
		const withPhotos: MmResultRow[] = [];

		for (let i = 0; i < this.rows.length; i += 1) {
			if (this.readPhotos(this.rows[i]).length > 0) {
				withPhotos.push(this.rows[i]);
			}
		}

		return withPhotos;
	}

	private refreshPhotoQueueFromRows(): void {
		if (this.photoQueue.length === 0) {
			return;
		}

		const rowByKey: { [key: string]: MmResultRow } = {};

		for (let i = 0; i < this.rows.length; i += 1) {
			rowByKey[this.rows[i].key] = this.rows[i];
		}

		const nextQueue: MmResultRow[] = [];

		for (let i = 0; i < this.photoQueue.length; i += 1) {
			const key = this.photoQueue[i].key;
			const fresh = rowByKey[key];

			nextQueue.push(fresh ? fresh : this.photoQueue[i]);
		}

		this.photoQueue = nextQueue;

		if (this.photoAnchorRow !== null) {
			const anchorFresh = rowByKey[this.photoAnchorRow.key];

			if (anchorFresh) {
				this.photoAnchorRow = anchorFresh;
			}
		}
	}

	private syncPhotoQueueRow(rowKey: string, row: MmResultRow): void {
		if (this.photoQueue.length === 0) {
			return;
		}

		for (let i = 0; i < this.photoQueue.length; i += 1) {
			if (this.photoQueue[i].key === rowKey) {
				this.photoQueue[i] = row;

				return;
			}
		}
	}

	private shouldAdvancePhotoAfterReview(
		action: MmBulkReviewAction,
		selectData: { [key: string]: any },
	): boolean {
		if (this.photoRowKey === '' || (action !== 'accept' && action !== 'reject')) {
			return false;
		}

		const row = this.photoRow;

		if (row === null || row.result === null) {
			return false;
		}

		const included = selectData[MM_RESULT_SELECTION_FIELDS.included];

		if (!Array.isArray(included)) {
			return false;
		}

		const resultId = String(row.result.id);

		for (let i = 0; i < included.length; i += 1) {
			if (String(included[i]) === resultId) {
				return true;
			}
		}

		return false;
	}

	private advancePhotoAfterDecision(): void {
		if (this.photoRowKey === '') {
			return;
		}

		const at = this.photoPosition;

		if (at === -1) {
			return;
		}

		const rows = this.photoRows;

		if (at < rows.length - 1) {
			this.handlePhotoPositionStep(1);
		}
	}

	get priceCheckerRecords(): MmPriceCheckerView[] {
		if (this.priceCheckerRow === null) {
			return [];
		}

		const source = this.priceCheckerRow.result;
		const raw: MmPriceCheckerRecord[] =
			source && Array.isArray(source.priceCheckerRecords) ? source.priceCheckerRecords : [];
		const records: MmPriceCheckerView[] = [];

		for (let i = 0; i < raw.length; i += 1) {
			const rec = raw[i];
			const id = rec && rec.id ? String(rec.id) : String(i);
			const src = this.priceCheckerPhotoSrc[id];
			records.push({
				id: id,
				price: formatMoney(rec ? rec.price : null),
				promoPrice: formatMoney(rec ? rec.promoPrice : null),
				capturedAt: formatDateTime(rec ? rec.capturedAt : null),
				photoSrc: src ? src : '',
				currency: orDash(this.readRawField(rec as any, 'currency')),
				gps: this.readGeo(rec as any),
				confidence: this.readConfidenceField(rec as any, 'confidence'),
				skipReason: orDash(this.skipReasonLabel(this.readRawField(rec as any, 'skipReason'))),
				skipComment: orDash(this.readRawField(rec as any, 'skipComment')),
				hasEdit: this.readFlagField(rec, 'wasEdited') === true,
				originalPrice: formatMoney(this.readNumberField(rec, 'originalPrice')),
				editedPrice: formatMoney(this.readNumberField(rec, 'editedPrice')),
			});
		}

		return records;
	}

	openPriceChecker(row: MmResultRow): void {
		this.revokePriceCheckerPhotos();
		this.priceCheckerRow = row;
		this.loadPriceCheckerPhotos(row);
	}

	closePriceChecker(): void {
		this.revokePriceCheckerPhotos();
		this.priceCheckerRow = null;
	}

	private loadPriceCheckerPhotos(row: MmResultRow): void {
		const source = row.result;
		const raw: MmPriceCheckerRecord[] =
			source && Array.isArray(source.priceCheckerRecords) ? source.priceCheckerRecords : [];

		for (let i = 0; i < raw.length; i += 1) {
			const rec = raw[i];

			if (!rec || !rec.id) {
				continue;
			}

			const kind: 'photo' | 'skip' = rec.photoUrl ? 'photo' : (rec.skipPhotoUrl ? 'skip' : 'photo');

			if (!rec.photoUrl && !rec.skipPhotoUrl) {
				continue;
			}

			const entryId = rec.id;
			fetchPriceCheckerPhoto(entryId, kind).then((response) => {
				if (this.priceCheckerRow !== row) {
					return;
				}

				const blob = response && response.data ? response.data : null;

				if (blob === null) {
					return;
				}

				const objectUrl = URL.createObjectURL(blob);
				this.priceCheckerObjectUrls.push(objectUrl);
				const next: { [entryId: string]: string } = Object.assign({}, this.priceCheckerPhotoSrc);
				next[entryId] = objectUrl;
				this.priceCheckerPhotoSrc = next;
			}).catch(() => {
			});
		}
	}

	private revokePriceCheckerPhotos(): void {
		for (let i = 0; i < this.priceCheckerObjectUrls.length; i += 1) {
			URL.revokeObjectURL(this.priceCheckerObjectUrls[i]);
		}

		this.priceCheckerObjectUrls = [];
		this.priceCheckerPhotoSrc = {};
	}

	private findLoadedRowKey(resultId: string): string {
		for (let i = 0; i < this.rows.length; i += 1) {
			const result = this.rows[i].result;

			if (result !== null && String(result.id) === String(resultId)) {
				return this.rows[i].key;
			}
		}

		return '';
	}

	private highlightRow(rowKey: string): void {
		this.highlightedKey = rowKey;

		this.$nextTick(() => {
			const root: any = this.$el;

			if (!root || typeof root.querySelector !== 'function') {
				return;
			}

			const element = root.querySelector('[data-row-key="' + rowKey + '"]');

			if (element && typeof element.scrollIntoView === 'function') {
				element.scrollIntoView({ block: 'center' });
			}
		});
	}

	/* Ключ хранения включает задание и отпечаток сессии; без отпечатка не сохраняем вовсе */

	private buildStorageKey(): string | null {
		const subject = getSpSessionFingerprint();

		if (subject === null || subject === '') {
			return null;
		}

		const rawScopeKey = this.ctx.scopeKey !== null && this.ctx.scopeKey !== ''
			? this.ctx.scopeKey
			: (this.ctx.scope === 'task' && this.taskId !== null ? this.taskId : '');

		if (rawScopeKey === '') {
			return null;
		}

		const scopeKey = (this.ctx.scope === 'batch' ? 'batch:' : 'task:') + String(rawScopeKey);

		return STORAGE_PREFIX + ':' + subject + ':' + scopeKey;
	}

	private persistViewState(): void {
		const key = this.buildStorageKey();

		if (key === null) {
			return;
		}

		const state: MmResultsViewState = {
			columns: this.visibleColumnKeys.slice(),
			onlyLatest: this.onlyLatest,
			onlyUnspecifiedOutcome: this.onlyUnspecifiedOutcome,
			onlyAnalogs: this.onlyAnalogs,
		};

		try {
			sessionStorage.setItem(key, JSON.stringify(state));
		} catch (e) {
		}
	}

	private restoreViewState(): void {
		const defaults = listDefaultVisibleResultColumns(this.taskType, this.ctx.scope);

		this.visibleColumnKeys = this.isPriceCheckerEnabled
			? defaults
			: defaults.filter((key) => key !== 'priceChecker');

		this.resetQuickFiltersToDefaults();

		const key = this.buildStorageKey();

		if (key === null) {
			this.syncQuickFilterDraftFromApplied();
			return;
		}

		let parsed: any = null;

		try {
			const raw = sessionStorage.getItem(key);

			parsed = raw === null ? null : JSON.parse(raw);
		} catch (e) {
			parsed = null;
		}

		if (parsed === null || typeof parsed !== 'object') {
			this.syncQuickFilterDraftFromApplied();
			return;
		}

		if (Array.isArray(parsed.columns)) {
			this.visibleColumnKeys = this.filterKnownColumns(parsed.columns);
		}

		this.onlyLatest = parsed.onlyLatest === true;
		this.onlyUnspecifiedOutcome = parsed.onlyUnspecifiedOutcome === true;
		this.onlyAnalogs = parsed.onlyAnalogs === true;
		this.syncQuickFilterDraftFromApplied();
		this.ensurePriceCheckerColumn();
	}

	private filterKnownColumns(source: any[]): string[] {
		const specs = this.columnCatalog;
		const result: string[] = [];

		for (let i = 0; i < specs.length; i += 1) {
			const spec = specs[i];

			if (!spec.toggleable || source.indexOf(spec.key) >= 0) {
				result.push(spec.key);
			}
		}

		return result;
	}

	private ensurePriceCheckerColumn(): void {
		if (!this.isPriceCheckerEnabled) {
			return;
		}

		if (this.visibleColumnKeys.indexOf('priceChecker') !== -1) {
			return;
		}

		this.visibleColumnKeys = this.visibleColumnKeys.concat(['priceChecker']);
	}

	private cancelSummaryRequest(): void {
		if (this.summarySource !== null) {
			this.summarySource.cancel();
			this.summarySource = null;
		}
	}

	private cancelListRequest(): void {
		if (this.listSource !== null) {
			this.listSource.cancel();
			this.listSource = null;
		}
	}

	private cancelPlanRequest(): void {
		if (this.planSource !== null) {
			this.planSource.cancel();
			this.planSource = null;
		}
	}

	private cancelAllRequests(): void {
		this.cancelSummaryRequest();
		this.cancelPlanRequest();
		this.cancelListRequest();
	}

	private resetQuickFiltersToDefaults(): void {
		this.onlyLatest = false;
		this.onlyUnspecifiedOutcome = false;
		this.onlyAnalogs = false;
		this.syncQuickFilterDraftFromApplied();
	}

	private resetAllState(): void {
		const wasPhotoOpen = this.isPhotoVisible;

		this.suppressPhotoFlush = true;
		this.aggregates = [];
		this.monitoringLevel = '';
		this.resultsTotal = 0;
		this.loadError = null;
		this.planItems = {};
		this.rows = [];
		this.listPagination = createPaginationState(GROUP_PAGE_SIZE);
		this.listStatus = 'idle';
		this.listError = null;
		this.listSource = null;
		this.hasLoadedRows = false;
		this.applyDefaultSorting();
		this.isDeepLinkMissed = false;
		this.highlightedKey = '';
		this.handledHighlightId = '';
		this.hasLoadedSummary = false;
		this.closeRowReject();
		this.closePhotos();
		this.closePriceChecker();
		this.exitEdit();
		resetSelection(this.selection);
		this.resetQuickFiltersToDefaults();
		this.$nextTick(() => {
			this.suppressPhotoFlush = false;
		});

		if (wasPhotoOpen) {
			this.notifyReviewComplete();
		}
	}
}
